import React, { useState, useEffect, useRef } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

//Redux
import { useDispatch, useSelector } from "react-redux"; //useDispatch

//Components
import Layout from "../../../../Layout/Layout";
import Constants from "../../../../common/SupplierConstants";
import CustomerConstants from "../../../../common/CustomerConstants";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import {
  addASNDetailNumber,
  addGRNDetailNumber,
  addInvoiceDetailNumber,
  addPoSelectedDetails,
  addSelectedItemList,
  addSesDetailNumber,
  addSubTransactionActivity,
  getPurchaseOrder,
  getSchedulingAgreement,
  getServicePO,
} from "../../../../redux/feature/supplier_app/purchasingSlice";
import { InputField } from "../../../../Components/formElements/InputField";
// import POCollabrationCommonFillter from "../../../Components/Filter/POCollabration/POCollabrationCommonFillter";

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";
import CustomerService from "../../../../services/customer_v2_appCommonService";

import {
  capitalize,
  currencyFormat,
  formatDate,
  formatDateWithAMPM,
} from "../../../../common/Validations";
import WorkflowApproveReject from "../../../../Components/Workflow/WorkflowApproveReject";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import { Modal } from "react-bootstrap";
import POTallyStatusSection from "./POTallyStatusSection";

const PurchaseOrderDetailedPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const divRef = useRef(null);

  let userData = useSelector((state) => state?.user); // User Details from Store

  let getConstantVar = useSelector((state) => state?.common?.data); // User getConstantVar from Store
  let userInfo = useSelector((state) => state?.user?.data); // User Details from Store
  let purchase_order_data = useSelector(
    (state) => state?.purchasing?.purchase_order?.data,
  ); // purchase_order_data Details from Store
  let poNumber = useSelector(
    (state) => state?.purchasing?.purchase_order?.poNumber,
  ); // purchase_order from Store
  let workflow = useSelector(
    (state) => state?.purchasing?.purchase_order?.workflowPO,
  ); // workflowPO from

  let config = useSelector(
    (state) => state?.common?.data?.purchaseOrder?.poDetailsPage,
  ); // config Details from Store

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [getHeaderData, setHeaderData] = useState(false);
  // console.log(">>getHeaderData", getHeaderData);
  // const updatedWorkflowRecord = {
  //   ...workflow,
  //   workflow_record: {
  //     ...workflow.workflow_record,
  //     vendorEmail: getHeaderData?.vendorEmail,
  //   },
  // };
  const updatedWorkflowRecord = {
    ...workflow,
    workflow_record: {
      ...(workflow?.workflow_record || {}),
      vendorEmail: getHeaderData?.vendorEmail,
    },
  };
  // console.log(">>updatedWorkflowRecord",updatedWorkflowRecord)
  // const [totalRows, setTotalRows] = useState(10);
  // const [perPage, setPerPage] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");

  const [getViewHeaderText, setViewHeaderText] = useState(false);

  const [disabled, setDisabled] = useState(false);
  // eslint-disable-next-line
  const [getSelectedData, setSelectedData] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const [getGrnHistoricalData, setGrnHistoricalData] = useState([]);
  const [getAsnHistoricalData, setAsnHistoricalData] = useState([]);
  const [getInvoiceHistoricalData, setInvoiceHistoricalData] = useState([]);
  const [getSesHistoricalData, setSesHistoricalData] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [getTwoWayMatch, setTwoWayMatch] = useState([]);
  const [getThreeWayMatch, setThreeWayMatch] = useState([]);

  // const [editMode, setEditMode] = useState(true);
  // eslint-disable-next-line
  const [showQCModal, setShowQCModal] = useState(false);
  // eslint-disable-next-line
  const [qcType, setQcType] = useState("");
  // eslint-disable-next-line
  const [selectedRow, setSelectedRow] = useState(null);

  const handleQCCheck = (type, row) => {
    // Find existing QC data
    const existingQC = qualityCheckItems.find(
      (item) => item.grnItemNr === row.grnItemNr && item.qcType === type,
    );

    setQcType(type);
    setSelectedRow({
      ...row,
      ...(existingQC || {}), //  Merge existing data
    });
    setShowQCModal(true);
  };
  const handleViewQC = (type, row) => {
    const savedQC = qualityCheckItems.find(
      (item) => item.grnItemNr === row.grnItemNr && item.qcType === type,
    );

    setQcType(type);
    setSelectedRow({
      ...row,
      ...(savedQC || {}), // ✅ Just merge, even if empty
    });
    setShowQCModal(true);
  };
  // eslint-disable-next-line
  const handleCheckboxClick = (type, row, e) => {
    e.preventDefault();

    const isChecked =
      type === "PHYSICAL" ? row.hasPhysicalQC : row.hasSpecificationQC;

    if (isChecked) {
      // Already checked - view existing data
      handleViewQC(type, row);
    } else {
      handleQCCheck(type, row);
    }
  };

  //Service Items
  // useEffect(() => {
  //   if (!Array.isArray(getThreeWayMatch) || getThreeWayMatch.length === 0)
  //     return;

  //   const updated = getThreeWayMatch.map((entry) => {
  //     let totalInvItemTaxValue = 0;
  //     let totalInvoicePrice = 0;

  //     entry.InvoiceRegister?.forEach((item) => {
  //       totalInvItemTaxValue += item.invItemTaxValue || 0;
  //       totalInvoicePrice += item.totalPrice || 0;
  //     });

  //     return {
  //       ...entry,
  //       totalInvItemTaxValue: +totalInvItemTaxValue.toFixed(2),
  //       totalInvoicePrice,
  //     };
  //   });

  //   setThreeWayMatch(updated); // ✅ update state with computed values
  //   console.log(">>getThreeWayMatch", getThreeWayMatch);
  // }, [getThreeWayMatch]);

  //  useEffect(() => {
  //   // if (!Array.isArray(getThreeWayMatch) || getThreeWayMatch.length === 0) return;

  //   const updated = getThreeWayMatch.map(entry => {
  //     let totalInvItemTaxValue = 0;
  //     let totalInvoicePrice = 0;

  //     entry.InvoiceRegister?.forEach(item => {
  //       totalInvItemTaxValue += item.invItemTaxValue || 0;
  //       totalInvoicePrice += item.totalPrice || 0;
  //     });

  //     return {
  //       ...entry,
  //       totalInvItemTaxValue: +totalInvItemTaxValue.toFixed(2),
  //       totalInvoicePrice,
  //     };
  //   });

  //   // Optional: Use a second state to avoid mutation loop
  //   // setComputedThreeWayMatch(updated);
  //   console.log(">>Updated getThreeWayMatch with totals:", updated);
  // }, []);

  let serviceColInfo = [
    {
      name: "Service Line Nr",
      cell: (row) => <span>{row.serviceLineNr} </span>,
      width: "180px",
    },
    {
      name: "Service Number",
      cell: (row) => <span>{row.serviceNr} </span>,
      width: "180px",
    },
    {
      name: "Service Desc",
      cell: (row) => <span>{row.serviceDescription} </span>,
      width: "180px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "180px",
    },
    {
      name: "Service Quantity",
      cell: (row) => <span>{row.serviceQuantity} </span>,
      width: "180px",
    },
    {
      name: "Unit Value",
      cell: (row) => <span>{row.unitValue} </span>,
      width: "180px",
    },
    {
      name: "Gross Value",
      cell: (row) => <span>{row.grossValue} </span>,
      width: "180px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "180px",
    },
  ];
  //ScheduleItems
  let scheduleColInfo = [
    {
      name: "Schedule LineNr",
      cell: (row) => <span>{row.scheduleLineNr} </span>,
      width: "180px",
    },
    {
      name: "Day/Week/Month",
      cell: (row) => <span>{row.schedulePeriod} </span>,
      width: "180px",
    },
    {
      name: "Schedule From",
      cell: (row) => <span>{row.scheduleFromDate} </span>,
      width: "180px",
    },
    {
      name: "Schedule To",
      cell: (row) => <span>{row.scheduleToDate} </span>,
      width: "180px",
    },
    {
      name: "Schedule Quantity",
      cell: (row) => <span>{row.scheduleQuantity} </span>,
      width: "180px",
    },
    {
      name: " Reservation No",
      cell: (row) => <span>{row.reservationNr} </span>,
      width: "180px",
    },
    {
      name: "Delivery Date",
      cell: (row) => <span>{row.deliveryDate} </span>,
      width: "180px",
    },
  ];
  const [getItemNr, setItemNr] = useState("");
  const [getServiceData, setServiceData] = useState([]);
  const [getServiceTableStatus, setServiceTableStatus] = useState(false);

  useEffect(() => {
    if (divRef.current) {
      try {
        // eslint-disable-next-line no-unused-vars
        const styles = window.getComputedStyle(divRef.current);
      } catch (error) {
        console.error("Failed to get computed style:", error);
      }
    }
  }, [getServiceTableStatus]);

  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Item Text Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  // OnClick on Header Text  Data

  // const headerTextShowModal = (headerTextData) => {
  //   setItemLevelData(headerTextData);
  //   setItemLevelColumns(lineItemColInfo);
  //   setModalTitle("Header Text Details");
  //   setViewHeaderText(true);
  // };
  const headerTextHideModal = () => {
    setViewHeaderText(false);
  };

  //--------------- Start Items Pop for history tables  -----------------------------------------------------

  // ASN Items
  let ASNLineItemColInfo = [
    {
      name: "Item Number",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material",
      cell: (row) => <span>{row.materialCode} </span>,
      width: "180px",
    },
    {
      name: "Material Desc",
      cell: (row) => <span>{row.materialDescription} </span>,
      width: "220px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialClass2} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "220px",
    },
    {
      name: "Price Unit",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "220px",
    },
  ];

  const [getASNitemLevelModalShow, setASNitemLevelModalShow] = useState(false);
  // OnClick on lineItem  Data
  const ASNLineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(ASNLineItemColInfo);
    setModalTitle("ASN Line Item Details");
    setASNitemLevelModalShow(true);
  };
  const ASNItemLevelHideModal = () => {
    setASNitemLevelModalShow(false);
  };

  // GRN Items
  let GRNLineItemColInfo = [
    {
      name: "Item Number",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material",
      cell: (row) => <span>{row.materialCode} </span>,
      width: "180px",
    },
    {
      name: "Material Desc",
      cell: (row) => <span>{row.materialDescription} </span>,
      width: "220px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialClass2} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "220px",
    },
    {
      name: "Price Unit",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "220px",
    },
  ];

  const [getGRNitemLevelModalShow, setGRNitemLevelModalShow] = useState(false);
  // OnClick on lineItem  Data
  const GRNLineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(GRNLineItemColInfo);
    setModalTitle("GRN Line Item Details");
    setGRNitemLevelModalShow(true);
  };
  const GRNLItemLevelHideModal = () => {
    setGRNitemLevelModalShow(false);
  };

  // Invoice Items
  let InvoiceLineItemColInfo = [
    {
      name: "Item Number",
      cell: (row) => <span>{row.invoiceItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material",
      cell: (row) => <span>{row.materialCode} </span>,
      width: "180px",
    },
    {
      name: "Material Desc",
      cell: (row) => <span>{row.materialDescription} </span>,
      width: "220px",
    },
    {
      name: "UOM",
      cell: (row) => <span>{row.orderUnitOfMeasure} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.invoiceQuantity} </span>,
      width: "220px",
    },
    {
      name: "Price Unit",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "220px",
    },
    {
      name: "Total Price",
      cell: (row) => <span>{row.totalPrice} </span>,
      width: "220px",
    },
    {
      name: "Tax %",
      cell: (row) => <span>{row.taxCode} </span>,
      width: "220px",
    },
    {
      name: "Total Tax",
      cell: (row) => <span>{row.totalTax} </span>,
      width: "220px",
    },
  ];
  const [getInvoiceitemLevelModalShow, setInvoiceitemLevelModalShow] =
    useState(false);
  // OnClick on lineItem  Data
  const InvoiceLineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(InvoiceLineItemColInfo);
    setModalTitle("Invoice Line Item Details");
    setInvoiceitemLevelModalShow(true);
  };
  const InvoiceItemLevelHideModal = () => {
    setInvoiceitemLevelModalShow(false);
  };

  // SES Items
  let SESLineItemColInfo = [
    {
      name: "Item Number",
      cell: (row) => <span>{row.purchasingDocumentItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material",
      cell: (row) => <span>{row.materialCode} </span>,
      width: "180px",
    },
    {
      name: "Material Desc",
      cell: (row) => <span>{row.materialDescription} </span>,
      width: "220px",
    },
    {
      name: "Material Group",
      cell: (row) => <span>{row.materialClass2} </span>,
      width: "220px",
    },
    {
      name: "Quantity",
      cell: (row) => <span>{row.purchaseQuantity} </span>,
      width: "220px",
    },
    {
      name: "Price Unit",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "220px",
    },
  ];

  const [getSESitemLevelModalShow, setSESitemLevelModalShow] = useState(false);
  // OnClick on lineItem  Data
  const SESLineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(SESLineItemColInfo);
    setModalTitle("SES Line Item Details");
    setSESitemLevelModalShow(true);
  };
  const SESLItemLevelHideModal = () => {
    setSESitemLevelModalShow(false);
  };

  // Three ModelGoodsMovement Item Cols
  let threeGoodsMovementCols = [
    {
      name: "PO Item Nr",
      cell: (row) => (
        <span className="bg-table-status bg-table-new-status w-50">
          {row.purchasingDocumentItemNr}
        </span>
      ),
      width: "130px",
    },
    {
      name: "GRN Nr",
      cell: (row) => (
        <span className="bg-table-status bg-table-new-status w-50">
          {row.grnNr}
        </span>
      ),
      width: "180px",
    },
    {
      name: "GRN Item Nr",
      cell: (row) => <span>{row.grnItemNr} </span>,
      width: "120px",
    },
    {
      name: "Material",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold">{row.materialCode} </p>
          <p className="p-0 m-0">{row.materialDescription} </p>
        </div>
      ),
      width: "100px",
    },
    {
      name: "PO Qty",
      cell: (row) => <span>{row.purchaseQuantity || "--"} </span>,
      width: "100px",
    },

    {
      name: "GRN Qty",

      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold text-primary">{row.grnQuantity} </p>
          <p className="p-0 m-0 text-primary">{row.orderUnitOfMeasure} </p>
        </div>
      ),
      width: "100px",
    },
    {
      name: "Total Price",
      cell: (row) => <span>{row.totalPrice || "--"} </span>,
      width: "100px",
    },
  ];

  let threeInvoiceRegisterCols = [
    {
      name: "PO Item Nr",
      cell: (row) => (
        <span className="bg-table-status bg-table-new-status w-50">
          {row.purchasingDocumentItemNr}
        </span>
      ),
      width: "180px",
    },
    {
      name: "INV Nr",
      cell: (row) => (
        <span className="bg-table-status bg-table-success-status w-50">
          {row.invoiceNr}
        </span>
      ),
      width: "180px",
    },
    {
      name: "INV Item Nr",
      cell: (row) => <span>{row.invoiceItemNr} </span>,
      width: "180px",
    },
    {
      name: "Material",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold">{row.materialCode} </p>
          <p className="p-0 m-0">{row.materialDescription} </p>
        </div>
      ),
      width: "220px",
    },
    {
      name: "PO Qty",
      cell: (row) => <span>{row.purchaseQuantity || "--"} </span>,
      width: "220px",
    },
    {
      name: "GRN Qty",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold text-primary">{row.grnQuantity} </p>
          <p className="p-0 m-0 text-primary">{row.orderUnitOfMeasure} </p>
        </div>
      ),
      width: "220px",
    },
    {
      name: "INV Qty",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold text-success">{row.invoiceQuantity} </p>
          <p className="p-0 m-0 text-success">{row.orderUnitOfMeasure} </p>
        </div>
      ),
      width: "100px",
    },
    // {
    //   name: "OrderUnit Of Measure",
    //    cell: (row) => (
    //     <div>
    //       <p className="p-0 m-0 fw-bold">{row.orderUnitOfMeasure || "--"} </p>
    //     </div>
    //   ),
    //   width: "220px",
    // },
    {
      name: "Order Price Unit",
      cell: (row) => <span>{row.orderPriceUnit} </span>,
      width: "220px",
    },
    {
      name: "Basic Value",
      cell: (row) => (
        <span className="fw-bold text-success">{row.totalPrice} </span>
      ),
      width: "220px",
    },
    {
      name: "Tax",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold text-success">
            {(parseFloat(row.totalPrice) / 100) * parseFloat(row.taxCode)}{" "}
          </p>
          {/* <p className="p-0 m-0 fw-bold">{row.taxAmount } </p> */}
          <p className="p-0 m-0 ">{row.taxCode}% </p>
        </div>
      ),
      width: "220px",
    },
    // {
    //   name: "INV Item Tax Value",
    //   cell: (row) => <span>{row.invItemTaxValue} </span>,
    //   width: "220px",
    // },
    {
      name: "Total Value",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold text-success">
            {(parseFloat(row.totalPrice) / 100) * parseFloat(row.taxCode) +
              parseFloat(row.totalPrice)}{" "}
          </p>
        </div>
      ),
      width: "220px",
    },
  ];

  const [getThreeTwoModalShow, setThreeTwoModalShow] = useState(false);
  // OnClick on lineItem  Data
  const threeTwoItemShowModal = (itemLevelData, titleName, modalItemCols) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(modalItemCols);
    setModalTitle(titleName);
    setThreeTwoModalShow(true);
  };
  const threeTwoItemHideModal = () => {
    setThreeTwoModalShow(false);
  };

  //---------------  END Items Pop for history tables   -----------------------------------------------------

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };

  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };

  const loadInitialPageData = async () => {
    setLoading(true);
    if (poNumber) {
      let obj = {
        documentNumber: poNumber,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });
      await ItemService.getPurchaseOrderDetail(obj).then((item) => {
        // console.log(">> Details res!", item);
        if (item?.status === 200) {
          setHeaderData(item?.data);
          setData(item?.data?.items);
          dispatch(addPoSelectedDetails(item?.data));
          loadInitialPageData1(item?.data?.qualityCheckDetails);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });

      setLoading(false);
    } else {
      window.history.back();
    }
  };

  const mapItemsWithQC = (items = [], qualityChecks = []) => {
    return items.map((rawItem) => {
      const item = rawItem.data ?? rawItem;

      const qcList = qualityChecks.filter(
        (qc) => Number(qc.grnItemNr) === Number(item.grnItemNr),
      );

      const physicalQC = qcList.find((qc) => qc.qcType === "PHYSICAL");
      const specificationQC = qcList.find(
        (qc) => qc.qcType === "SPECIFICATION",
      );

      const hasPhysicalQC =
        !!physicalQC &&
        (physicalQC.packagingCondition ||
          physicalQC.physicalDamage ||
          physicalQC.quantityVerified ||
          physicalQC.inspectionRemarks);

      const hasSpecificationQC =
        !!specificationQC &&
        (specificationQC.modelMatch ||
          specificationQC.brandMatch ||
          specificationQC.sizeGradeMatch ||
          specificationQC.technicalParamsOk);

      return {
        // ---------- FULL ITEM
        ...item,

        // ---------- NORMALIZE (barcode safe)
        mrPrice: Number(item.mrPrice) || 0,
        iphslrPrice: Number(item.iphslrPrice) || 0,
        pcdlrPrice: Number(item.pcdlrPrice) || 0,
        orderPriceUnit: Number(item.orderPriceUnit) || 0,
        purchaseQuantity: Number(item.purchaseQuantity) || 0,

        // ---------- QC FLAGS
        hasPhysicalQC,
        hasSpecificationQC,

        // ---------- HEADER BUYBACK (ensure boolean)
        buyBackItem: Boolean(item.buyBackItem),

        // ---------- UI FLAT FIELDS (PHYSICAL)
        packagingCondition: physicalQC?.packagingCondition || "",
        physicalDamage: physicalQC?.physicalDamage || "",
        quantityVerified: physicalQC?.quantityVerified || "",
        inspectionRemarks: physicalQC?.inspectionRemarks || "",

        // ---------- UI FLAT FIELDS (SPECIFICATION)
        modelMatch: specificationQC?.modelMatch || "",
        brandMatch: specificationQC?.brandMatch || "",
        sizeGradeMatch: specificationQC?.sizeGradeMatch || "",
        technicalParamsOk: specificationQC?.technicalParamsOk || "",

        // ---------- QC OBJECTS
        physical: hasPhysicalQC
          ? {
              ...physicalQC,
              buyBackItem: Boolean(item.buyBackItem),
            }
          : null,

        specification: hasSpecificationQC
          ? {
              ...specificationQC,
              buyBackItem: Boolean(item.buyBackItem),
            }
          : null,

        // ---------- FULL QC ARRAY (inject header buyBackItem)
        qualityCheckDetails: qcList.length
          ? qcList.map((qc) => ({
              ...qc,
              buyBackItem: Boolean(item.buyBackItem),
            }))
          : [],
      };
    });
  };
  const [qualityCheckItems, setQualityCheckItems] = useState([]);

  const sortedQualityCheckItems = React.useMemo(() => {
    return [...qualityCheckItems].sort(
      (a, b) => Number(a.grnItemNr) - Number(b.grnItemNr),
    );
  }, [qualityCheckItems]);
  // console.log(">>sortedQualityCheckItems", sortedQualityCheckItems);

  // const loadInitialPageData1 = async () => {
  //   setLoading(true);

  //   const toastId = toast.loading("Loading...", {
  //     position: "top-right",
  //   });

  //   try {
  //     const allMappedItems = [];

  //     for (const qcDetail of getHeaderData?.qualityCheckDetails) {
  //       const payload = {
  //         queryName: "getQualityCheckDetail",
  //         documentNumber: qcDetail.qualityCheckNr, // 👈 pass each qualityCheckNr one by one
  //         page: 1,
  //         per_page: 10,
  //         timeZone: "Asia/Calcutta",
  //       };

  //       const response = await ItemService.generateQuery(payload);

  //       if (response?.status === 200) {
  //         const qcData = response?.data?.[0];

  //         if (!qcData) {
  //           console.warn(
  //             `Quality Check not found for: ${qcDetail.qualityCheckNr}`,
  //           );
  //           continue; // skip this one, continue to next
  //         }

  //         const mappedData = mapItemsWithQC(
  //           qcData.items || [],
  //           qcData.qualityChecks || [],
  //         );

  //         allMappedItems.push(...mappedData); // 👈 accumulate results
  //       } else {
  //         console.warn(
  //           `Failed to load data for ${qcDetail.qualityCheckNr}:`,
  //           response?.message,
  //         );
  //       }
  //     }

  //     setQualityCheckItems(allMappedItems); // 👈 set all at once after loop
  //   } catch (error) {
  //     console.error(error);
  //     toast.error("Something went wrong");
  //   } finally {
  //     toast.dismiss(toastId);
  //     setLoading(false);
  //   }
  // };

  //load Two Way Match Data
  // eslint-disable-next-line no-unused-vars

  // ✅ Accept qualityCheckDetails as a parameter instead of reading from state
  // const loadInitialPageData1 = async (qualityCheckDetails = []) => {
  //   if (!qualityCheckDetails?.length) return; // guard: nothing to process

  //   setLoading(true);

  //   const toastId = toast.loading("Loading...", { position: "top-right" });

  //   try {
  //     const allMappedItems = [];

  //     for (const qcDetail of qualityCheckDetails) {
  //       const payload = {
  //         queryName: "getQualityCheckDetail",
  //         documentNumber: qcDetail.qualityCheckNr,
  //         page: 1,
  //         per_page: 10,
  //         timeZone: "Asia/Calcutta",
  //       };

  //       const response = await ItemService.generateQuery(payload);

  //       if (response?.status === 200) {
  //         const qcData = response?.data?.[0];

  //         if (!qcData) {
  //           console.warn(
  //             `Quality Check not found for: ${qcDetail.qualityCheckNr}`,
  //           );
  //           continue;
  //         }

  //         const mappedData = mapItemsWithQC(
  //           qcData.items || [],
  //           qcData.qualityChecks || [],
  //         );

  //         allMappedItems.push(...mappedData);
  //       } else {
  //         console.warn(
  //           `Failed to load data for ${qcDetail.qualityCheckNr}:`,
  //           response?.message,
  //         );
  //       }
  //     }

  //     setQualityCheckItems(allMappedItems);
  //   } catch (error) {
  //     console.error(error);
  //     toast.error("Something went wrong");
  //   } finally {
  //     toast.dismiss(toastId);
  //     setLoading(false);
  //   }
  // };
  const loadInitialPageData1 = async (qualityCheckDetails = []) => {
    if (!qualityCheckDetails?.length) return;

    setLoading(true);
    const toastId = toast.loading("Loading...", { position: "top-right" });

    try {
      const allMappedItems = [];

      for (const qcDetail of qualityCheckDetails) {
        const payload = {
          queryName: "getQualityCheckDetail",
          documentNumber: qcDetail.qualityCheckNr,
          page: 1,
          per_page: 10,
          timeZone: "Asia/Calcutta",
        };

        const response = await ItemService.generateQuery(payload);

        if (response?.status === 200) {
          const qcData = response?.data?.[0];

          if (!qcData) {
            console.warn(
              `Quality Check not found for: ${qcDetail.qualityCheckNr}`,
            );
            continue;
          }

          const mappedData = mapItemsWithQC(
            qcData.items || [],
            qcData.qualityChecks || [],
          ).map((item) => ({
            ...item,
            qualityCheckNr: qcDetail.qualityCheckNr, // ✅ attach the qualityCheckNr to each item
          }));

          allMappedItems.push(...mappedData);
        } else {
          console.warn(
            `Failed to load data for ${qcDetail.qualityCheckNr}:`,
            response?.message,
          );
        }
      }

      setQualityCheckItems(allMappedItems);
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong");
    } finally {
      toast.dismiss(toastId);
      setLoading(false);
    }
  };

  // eslint-disable-next-line
  const loadTwoWayMatchData = async () => {
    let obj = {
      queryName: "2_WAY_MATCHING_BY_PO",
      page: 1,
      per_page: 10,
      purchasingDocumentNr: poNumber,
    };
    await ItemService.generateQuery(obj).then((item) => {
      // console.log(">> res!", item);
      if (item?.status === 200) {
        setTwoWayMatch(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  //load Three Way Match Data
  const loadThreeWayMatchData = async () => {
    let obj = {
      queryName: "3_WAY_MATCHING_BY_PO",
      page: 1,
      per_page: 10,
      purchasingDocumentNr: poNumber,
    };
    await ItemService.generateQuery(obj).then((item) => {
      // console.log(">> res!", item);
      if (item?.status === 200) {
        setThreeWayMatch(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  useEffect(() => {
    loadInitialPageData(); // fetch page 1 of users
    loadGrnHistoricalData(); // Load GRN History Data
    loadAsnHistoricalData(); // Load ASN History Data
    loadInvoiceHistoricalData(); // Load Invoice History Data
    loadSesHistoricalData(); // Load SES History Data

    // loadTwoWayMatchData(); // Load Two way matching Data // Not required
    loadThreeWayMatchData(); // Load Three way matching Data
    dispatch(addSelectedItemList([]));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poNumber, purchase_order_data]);

  const detailedPageGRN = (grnNumber) => {
    dispatch(addGRNDetailNumber(grnNumber));
    // navigate(Constants.POCOLLABRATION_GRN_DETAILS);
    navigate(CustomerConstants.CUSTOMER_V5_MR_POCOLLABRATION_GRN_DETAILS);
  };

  const detailedPageASN = (ansNumber) => {
    dispatch(addASNDetailNumber(ansNumber));
    navigate(Constants.POCOLLABRATION_ASN_DETAIL_PAGE);
  };

  const detailedPageInvoice = (ansNumber) => {
    dispatch(addInvoiceDetailNumber(ansNumber));
    navigate(Constants.POCOLLABRATION_INVOICE_DETIAILS);
  };

  const detailedPageSES = (sesNumber) => {
    dispatch(addSesDetailNumber(sesNumber));
    navigate(
      CustomerConstants.CUSTOMER_V5_MR_POCOLLABRATION_SERVICE_ENTRY_DETAILS,
    );
  };

  // PO columns Details
  /* const columns = [
    {
      name: "PO Number",
      selector: (row) => poNumber,
      sortable: false,
      width: "150px",
    },
    // {
    //   name: "PO Item Nr",
    //   selector: (row) => row.purchasingDocumentItemNr,
    //   // selector: (row) => row.purchasingReqDocumentItemNr,
    //   sortable: false,
    //   width: "150px",
    // },
     {
      name: "PO Item Nr",
      selector: (row) =>
        row.purchasingDocumentItemNr != null
          ? row.purchasingDocumentItemNr
          : row.purchasingReqDocumentItemNr ?? "--",
      sortable: false,
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.statusItem} />
        </>
      ),
      width: "160px",
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      sortable: false,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
    },
    {
      name: "Item Text",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
      width: "100px",
    },
    // {
    //   name: "Purchase Quantity",
    //   selector: (row) => row.purchaseQuantity,
    //   sortable: false,
    //   width: "180px",
    // },
     {
      name: "Purchase Quantity",
      cell: (row) => (
        <span>
          {row.quotationDocument?.[0]?.awardQty != null
            ? row.quotationDocument[0].awardQty
            : row.purchaseQuantity ?? "--"}
        </span>
        // <span>{row.quotationDocument?.[0]?.awardQty ?? "--"}</span>

      ),
      sortable: false,
      width: "180px",
    },
   
    {
      name: "Order Unit",
      selector: (row) => row.orderUnitOfMeasure,
      sortable: false,
      width: "120px",
    },
    // {
    //   name: "Unit Price",
    //   selector: (row) => row.orderPriceUnit,
    //   sortable: false,
    //   width: "120px",
    // },
    {
      name: "Unit Price",
      selector: (row) =>
        row?.quotationDocument?.[0]?.quotationUnitPrice != null
          ? row.quotationDocument[0].quotationUnitPrice
          : row.orderPriceUnit ?? "--",
      sortable: false,
      width: "120px",
    },
    
    // {
    //   name: "Item Value",
    //   selector: (row) => row.netValue,
    //   // cell: (row) => (
    //   //   <span className="numberFormate m-0 p-0 pt-1 fw-bold">
    //   //     {   row?.quotationDocument &&
    //   //       row?.quotationDocument[0] && row?.quotationDocument[0]?.awardValue
    //   //     }
    //   //   </span>
    //   // ),

    //   sortable: false,
    //   width: "180px",
    // },
    {
      name: "Item Value",
      selector: (row) =>
        row?.quotationDocument?.[0]?.awardValue != null
          ? row.quotationDocument[0].awardValue
          : row.netValue ?? "--",
      sortable: false,
      width: "180px",
    },

    {
      name: "Currency",
      selector: (row) => row.currencyCode,
      sortable: false,
      width: "120px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate,
      sortable: false,
      width: "140px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount,
      sortable: false,
      width: "200px",
    },
    // {
    //   name: "Price Unit Qty",
    //   selector: (row) => row.priceUnit,
    //   sortable: false,
    //   width: "200px",
    // },
    {
      name: "Tax Code",
      selector: (row) => row.taxId,
      sortable: false,
      width: "200px",
    },
    {
      name: "Tax Desc",
      selector: (row) => row.taxIdDesc,
      sortable: false,
      width: "200px",
    },
    {
      name: "Free Of Cost",
      selector: (row) => row.freeCost,
      sortable: false,
      width: "200px",
    },
    {
      name: "Purch Req Nr",
      selector: (row) => row.requestNumber,
      sortable: false,
      width: "200px",
    },
    {
      name: "PR Item Nr",
      selector: (row) => row.prItemNr,
      sortable: false,
      width: "200px",
    },
    // {
    //   name: "ExcessTolerance",
    //   selector: (row) => row.excessTolerance,
    //   sortable: false,
    //   width: "200px",
    // },
    // {
    //   name: "ShortageTolerance",
    //   selector: (row) => row.shortageTolerance,
    //   sortable: false,
    //   width: "200px",
    // },
  ];
 */
  const columns = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      // sortable: false,
      width: "180px",
    },
    /*  {
        name: "Item Text",
        selector: (row) => row.local_id || "--",
        sortable: false,
        width: "110px",
        cell: (row) => (
          <>
            <span
              style={{ marginLeft: "12px" }}
              onClick={() =>
                showLineItemHeaderText(row.local_id, row.itemTextData)
              }
            >
              <i className="bi bi-calendar2-week iconTable"></i>
            </span>
            <span className="suppliersIcon">
              {" "}
              {row.itemTextData?.length || 0}{" "}
            </span>
          </>
        ),
      }, */
    {
      name: "Material/Service",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold">{row.materialCode}</p>
          <p className="p-0 m-0 fw-bold">{row.materialDescription}</p>
        </div>
        // <InputField
        //   className="inputBox mt-1"
        //   // label="Please Enter the Remarks*"
        //   name="materialCode"
        //   placeholder=""
        //   value={row.materialCode || ""}
        //   // onChange={(event) => handleInputChange(row.local_id, event)}
        // />
      ),
      sortable: false,
      width: "200px",
    },
    // {
    //   name: "Description",
    //   selector: (row) => row.materialDescription || "--",
    //   cell: (row) => (
    //     <TextAreaField
    //       className="inputBox mt-1"
    //       name="materialDescription"
    //       placeholder=""
    //       value={row.materialDescription || ""}
    //       // onChange={(event) => handleInputChange(row.local_id, event)}
    //       disabled={true}
    //     />
    //   ),
    //   sortable: false,
    //   width: "200px",
    // },
    /* {
        name: "Material Group ",
        selector: (row) => row.materialGroup || "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            // label="Please Enter the Remarks*"
            name="materialGroup"
            placeholder=""
            value={row.materialGroup || ""}
            onChange={(event) => handleInputChange(row.local_id, event)}
          />
        ),
        sortable: false,
        width: "200px",
      }, */
    {
      name: "Quantity",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <div className="d-flex flex-column">
          <span className="p-0 m-0 fw-bold">{row.purchaseQuantity}</span>
          <span className="p-0 m-0 fw-bold">{row.orderUnitOfMeasure}</span>
        </div>
      ),
      sortable: false,
      width: "130px",
    },
    // {
    //   name: "UOM ",
    //   selector: (row) => row.orderUnitOfMeasure || "--",
    //   cell: (row) => (
    //     <InputField
    //       className="inputBox mt-1"
    //       name="orderUnitOfMeasure"
    //       placeholder=""
    //       value={row.orderUnitOfMeasure || ""}
    //       // onChange={(event) => handleInputChange(row.local_id, event)}
    //       disabled={true}
    //     />
    //   ),
    //   width: "200px",
    // },
    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold">
            {/* {row?.unitPrice || row.orderPriceUnit} */}
            {row?.orderPriceUnit ?? row.unitPrice}
          </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Item Value",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <div className="d-flex flex-column">
          {/* <sapn className="p-0 m-0 fw-bold">{row.netValue}</sapn> */}
          <span className="p-0 m-0 fw-bold">
            {row.netValue != null ? Number(row.netValue).toFixed(2) : "--"}
          </span>
          <span className="p-0 m-0 fw-bold text-primary">
            {row.currencyCode || "INR"}
          </span>
        </div>
      ),
      width: "130px",
    },
    // {
    //   name: "Currency ",
    //   selector: (row) => row.currencyCode || "INR",
    //   width: "200px",
    // },
    {
      name: "Gst Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <div>
          {/* <p className="p-0 m-0 fw-bold">{row.taxAmount}</p> */}
          <p className="p-0 m-0 fw-bold">
            {row.taxAmount != null ? Number(row.taxAmount).toFixed(2) : "--"}
          </p>
        </div>
      ),
      sortable: false,
      width: "130px",
    },
    {
      name: "GST Code % ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold">{row.taxCode}</p>
        </div>
      ),
      sortable: false,
      width: "130px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row?.deliveryDate || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold">{formatDate(row?.deliveryDate)}</p>
        </div>
      ),
      width: "130px",
    },

    {
      name: "Storage Location",
      selector: (row) => row.storageLocation || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold">{row.storageLocation}</p>
        </div>
      ),
      sortable: false,
      width: "160px",
    },
    // {
    //   name: "Delete",
    //   selector: (row) => row.local_id || "--",
    //   sortable: false,
    //   cell: (row) => (
    //     <button
    //       className="btn btn-danger"
    //       onClick={() => removePOItemRow(row.local_id)}
    //     >
    //       <i className="bi bi-trash3"></i>
    //     </button>
    //   ),
    //   width: "120px",
    // },
  ];
  const columnsService = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: false,
      width: "180px",
    },
    {
      name: "Service",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServiceItemTable(row.services, row.purchasingDocumentItemNr)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.services?.length || 0} </span>
        </>
      ),
      width: "180px",
    },
    /*  {
        name: "Item Text",
        selector: (row) => row.local_id || "--",
        sortable: false,
        width: "110px",
        cell: (row) => (
          <>
            <span
              style={{ marginLeft: "12px" }}
              onClick={() =>
                showLineItemHeaderText(row.local_id, row.itemTextData)
              }
            >
              <i className="bi bi-calendar2-week iconTable"></i>
            </span>
            <span className="suppliersIcon">
              {" "}
              {row.itemTextData?.length || 0}{" "}
            </span>
          </>
        ),
      }, */
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0 fw-bold">{row.materialCode}</p>
          <p className="p-0 m-0">{row.materialDescription}</p>
        </div>
        // <InputField
        //   className="inputBox mt-1"
        //   // label="Please Enter the Remarks*"
        //   name="materialCode"
        //   placeholder=""
        //   value={row.materialCode || ""}
        //   // onChange={(event) => handleInputChange(row.local_id, event)}
        // />
      ),
      sortable: false,
      width: "200px",
    },
    // {
    //   name: "Description",
    //   selector: (row) => row.materialDescription || "--",
    //   cell: (row) => (
    //     <TextAreaField
    //       className="inputBox mt-1"
    //       name="materialDescription"
    //       placeholder=""
    //       value={row.materialDescription || ""}
    //       // onChange={(event) => handleInputChange(row.local_id, event)}
    //       disabled={true}
    //     />
    //   ),
    //   sortable: false,
    //   width: "200px",
    // },
    /* {
        name: "Material Group ",
        selector: (row) => row.materialGroup || "--",
        cell: (row) => (
          <InputField
            className="inputBox mt-1"
            // label="Please Enter the Remarks*"
            name="materialGroup"
            placeholder=""
            value={row.materialGroup || ""}
            onChange={(event) => handleInputChange(row.local_id, event)}
          />
        ),
        sortable: false,
        width: "200px",
      }, */
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <div>
          <span className="p-0 m-0 fw-bold">{row.purchaseQuantity}</span>
          <span className="p-0 m-0">{row.orderUnitOfMeasure}</span>
        </div>
      ),
      sortable: false,
      width: "130px",
    },
    // {
    //   name: "UOM ",
    //   selector: (row) => row.orderUnitOfMeasure || "--",
    //   cell: (row) => (
    //     <InputField
    //       className="inputBox mt-1"
    //       name="orderUnitOfMeasure"
    //       placeholder=""
    //       value={row.orderUnitOfMeasure || ""}
    //       // onChange={(event) => handleInputChange(row.local_id, event)}
    //       disabled={true}
    //     />
    //   ),
    //   width: "200px",
    // },
    {
      name: "Unit Price ",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0">{row.orderPriceUnit}</p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <div>
          {/* <sapn className="p-0 m-0 fw-medium">{row.netValue}</sapn> */}
          <span className="p-0 m-0 fw-medium">
            {row.netValue != null ? Number(row.netValue).toFixed(2) : "--"}
          </span>
          <span className="p-0 m-0 ">{row.currencyCode || "INR"}</span>
        </div>
      ),
      width: "130px",
    },
    // {
    //   name: "Currency ",
    //   selector: (row) => row.currencyCode || "INR",
    //   width: "200px",
    // },
    {
      name: "GST Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <div>
          {/* <p className="p-0 m-0">{row.taxAmount}</p> */}
          <p className="p-0 m-0">
            {row.taxAmount != null ? Number(row.taxAmount).toFixed(2) : "--"}
          </p>
        </div>
      ),
      sortable: false,
      width: "130px",
    },
    {
      name: "GST Code % ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0">{row.taxCode}</p>
        </div>
      ),
      sortable: false,
      width: "130px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0">{row.deliveryDate}</p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0">{row.plant}</p>
        </div>
      ),
      sortable: false,
      width: "130px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocation || "--",
      cell: (row) => (
        <div>
          <p className="p-0 m-0">{row.storageLocation}</p>
        </div>
      ),
      sortable: false,
      width: "160px",
    },
    // {
    //   name: "Delete",
    //   selector: (row) => row.local_id || "--",
    //   sortable: false,
    //   cell: (row) => (
    //     <button
    //       className="btn btn-danger"
    //       onClick={() => removePOItemRow(row.local_id)}
    //     >
    //       <i className="bi bi-trash3"></i>
    //     </button>
    //   ),
    //   width: "120px",
    // },
  ];

  // const columnsService = [
  //   {
  //     name: "PO Number",
  //     selector: (row) => poNumber,
  //     sortable: false,
  //     width: "150px",
  //   },
  //   {
  //     name: "PO Item Nr",
  //     selector: (row) => row.purchasingDocumentItemNr,
  //     sortable: false,
  //     width: "150px",
  //   },
  //   {
  //     name: "Status",
  //     cell: (row) => (
  //       <>
  //         <TableStatusField status={row.statusItem} />
  //       </>
  //     ),
  //     width: "160px",
  //   },
  //   {
  //     name: "Material/Service",
  //     selector: (row) => row.materialCode,
  //     sortable: false,
  //     width: "150px",
  //     cell: (row) => (
  //       <div>
  //         <p className="m-0 p-0 fw-bold text-primary">
  //           {row.materialDescription}{" "}
  //         </p>
  //         <p className="m-0 p-0 pt-1 ">{row.materialCode} </p>
  //       </div>
  //     ),
  //   },
  //   {
  //     name: "Item Text",
  //     cell: (row) => (
  //       <>
  //         <span
  //           style={{ marginLeft: "12px" }}
  //           onClick={() => lineItemShowModal(row.itemTextData)}
  //         >
  //           <i className="bi bi-calendar2-week iconTable"></i>
  //         </span>
  //         <span className="suppliersIcon">
  //           {" "}
  //           {row.itemTextData?.length || 0}{" "}
  //         </span>
  //       </>
  //     ),
  //     width: "100px",
  //   },
  //   {
  //     name: "Service",
  //     cell: (row) => (
  //       <>
  //         <span
  //           style={{ marginLeft: "12px" }}
  //           onClick={() =>
  //             showServiceItemTable(row.services, row.purchasingDocumentItemNr)
  //           }
  //         >
  //           <i className="bi bi-calendar2-week iconTable"></i>
  //         </span>
  //         <span className="suppliersIcon"> {row.services?.length || 0} </span>
  //       </>
  //     ),
  //     width: "180px",
  //   },
  //   {
  //     name: "Purchase Quantity",
  //     selector: (row) => row.purchaseQuantity,
  //     sortable: false,
  //     width: "180px",
  //   },
  //   {
  //     name: "Order Unit",
  //     selector: (row) => row.orderUnitOfMeasure,
  //     sortable: false,
  //     width: "120px",
  //   },
  //   {
  //     name: "Unit Price",
  //     selector: (row) => row.orderPriceUnit,
  //     sortable: false,
  //     width: "120px",
  //   },
  //   {
  //     name: "Item Value",
  //     // selector: (row) => row.netValue,
  //     cell: (row) => (
  //       <span className="numberFormate m-0 p-0 pt-1 fw-bold">
  //         {currencyFormat(Number(row.netValue).toFixed(2))}
  //       </span>
  //     ),

  //     sortable: false,
  //     width: "180px",
  //   },
  //   {
  //     name: "Currency",
  //     selector: (row) => row.currencyCode,
  //     sortable: false,
  //     width: "120px",
  //   },
  //   {
  //     name: "Delivery Date",
  //     selector: (row) => row.deliveryDate,
  //     sortable: false,
  //     width: "140px",
  //   },
  //   {
  //     name: "Tax Amount",
  //     selector: (row) => row.taxAmount,
  //     sortable: false,
  //     width: "200px",
  //   },
  //   // {
  //   //   name: "Price Unit Qty",
  //   //   selector: (row) => row.priceUnit,
  //   //   sortable: false,
  //   //   width: "200px",
  //   // },
  //   {
  //     name: "Tax Code",
  //     selector: (row) => row.taxId,
  //     sortable: false,
  //     width: "200px",
  //   },
  //   {
  //     name: "Tax Desc",
  //     selector: (row) => row.taxIdDesc,
  //     sortable: false,
  //     width: "200px",
  //   },
  //   {
  //     name: "Free Of Cost",
  //     selector: (row) => row.freeCost,
  //     sortable: false,
  //     width: "200px",
  //   },
  //   {
  //     name: "Purch Req Nr",
  //     selector: (row) => row.requestNumber,
  //     sortable: false,
  //     width: "200px",
  //   },
  //   {
  //     name: "PR Item Nr",
  //     selector: (row) => row.prItemNr,
  //     sortable: false,
  //     width: "200px",
  //   },
  //   {
  //     name: "ExcessTolerance",
  //     selector: (row) => row.excessTolerance,
  //     sortable: false,
  //     width: "200px",
  //   },
  //   {
  //     name: "ShortageTolerance",
  //     selector: (row) => row.shortageTolerance,
  //     sortable: false,
  //     width: "200px",
  //   },
  // ];

  const columnsSchedule = [
    {
      name: "PO Number",
      selector: (row) => poNumber,
      sortable: false,
      width: "150px",
    },
    {
      name: "PO Item Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: false,
      width: "150px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <TableStatusField status={row.statusItem} />
        </>
      ),
      width: "160px",
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      sortable: false,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
    },
    {
      name: "Service",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServiceItemTable(row.services, row.purchasingDocumentItemNr)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.services?.length || 0} </span>
        </>
      ),
      width: "180px",
    },
    {
      name: "Item Text",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
      width: "100px",
    },
    {
      name: "Schedules",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              showServiceItemTable(row.schedule, row.purchasingDocumentItemNr)
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.schedule?.length || 0} </span>
        </>
      ),
      width: "180px",
    },
    {
      name: "Purchase Quantity",
      selector: (row) => row.purchaseQuantity,
      sortable: false,
      width: "180px",
    },
    {
      name: "Oder Unit",
      selector: (row) => row.orderUnitOfMeasure,
      sortable: false,
      width: "120px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit,
      sortable: false,
      width: "120px",
    },
    {
      name: "Item Value",
      // selector: (row) => row.netValue,
      cell: (row) => (
        <span className="numberFormate">
          {currencyFormat(Number(row.netValue).toFixed(2))}
        </span>
      ),

      sortable: false,
      width: "180px",
    },
    {
      name: "Currency",
      selector: (row) => row.currencyCode,
      sortable: false,
      width: "120px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate,
      sortable: false,
      width: "140px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount,
      sortable: false,
      width: "200px",
    },
    // {
    //   name: "Price Unit Qty",
    //   selector: (row) => row.priceUnit,
    //   sortable: false,
    //   width: "200px",
    // },
    {
      name: "Tax Code",
      selector: (row) => row.taxId,
      sortable: false,
      width: "200px",
    },
    {
      name: "Tax Desc",
      selector: (row) => row.taxIdDesc,
      sortable: false,
      width: "200px",
    },
    {
      name: "Free Of Cost",
      selector: (row) => row.freeCost,
      sortable: false,
      width: "200px",
    },
    {
      name: "Purch Req Nr",
      selector: (row) => row.requestNumber,
      sortable: false,
      width: "200px",
    },
    {
      name: "PR Item Nr",
      selector: (row) => row.prItemNr,
      sortable: false,
      width: "200px",
    },
    {
      name: "ExcessTolerance",
      selector: (row) => row.excessTolerance,
      sortable: false,
      width: "200px",
    },
    {
      name: "ShortageTolerance",
      selector: (row) => row.shortageTolerance,
      sortable: false,
      width: "200px",
    },
  ];

  // PO items columns Details
  const lineItemColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  //GRN Historical Table
  const grnHistoryColInfo = [
    {
      name: "GRN Number",
      selector: (row) => row.grnNr,
      cell: (row) => (
        <button className="btnInfo" onClick={() => detailedPageGRN(row.grnNr)}>
          {row.grnNr}{" "}
        </button>
      ),
      sortable: false,
      width: "150px",
    },

    {
      name: "Status",
      selector: (row) => row.grnStatusHeader,
      cell: (row) => (
        <>
          <TableStatusField status={row.grnStatusHeader} />
        </>
      ),
      sortable: false,
      width: "160px",
    },
    {
      name: "GRN Date",
      selector: (row) => row.updatedAt || "--",
      cell: (row) => (
        <>
          <div>{formatDateWithAMPM(row.updatedAt)}</div>
        </>
      ),

      sortable: false,
      width: "150px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => GRNLineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: false,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },

    {
      name: "GRN Value",
      selector: (row) => row.sumOfGrn || "--",
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 fw-bold">{row.sumOfGrn}</p>
            <p className="m-0 p-0">{row.currencyCode}</p>
          </div>
        </>
      ),
      sortable: false,
      width: "150px",
    },
    // {
    //   name: "Currency",
    //   selector: (row) => row.currencyCode || "--",

    //   width: "150px",
    // },
    // {
    //   name: "Purchase Order",
    //   selector: (row) => row.items[0]?.purchasingDocumentNr || "--",
    //   sortable: false,
    //   width: "150px",
    // },
    {
      name: "Delivery Note",
      selector: (row) => row.deliveryNoteNo || "--",
      sortable: false,
      width: "140px",
    },
  ];

  // ASN Historical Table
  const asnHistoryColInfo = [
    {
      name: "ASN Number",
      selector: (row) => row.asnNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageASN(row.asnNumber)}
        >
          {row.asnNumber}{" "}
        </button>
      ),
      sortable: false,
      width: "150px",
    },
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span>
            <i className="bi bi-git iconTable"></i>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Status",
      selector: (row) => row.asnStatusHeader,
      cell: (row) => (
        <>
          <TableStatusField status={row.asnStatusHeader} />
        </>
      ),
      sortable: false,
      width: "160px",
    },
    {
      name: "ASN Date",
      selector: (row) => row.asnDate || "--",
      sortable: false,
      width: "150px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => ASNLineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: false,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },
    {
      name: "SAP IBD ",
      selector: (row) => row.sapInboundDelivery || "--",
      sortable: false,
      width: "180px",
    },
    {
      name: "SAP GRN",
      selector: (row) => row.grnNumber || "--",
      sortable: false,
      width: "180px",
    },
    {
      name: "Posted On",
      selector: (row) => row.postedOn || "--",
      sortable: false,
      width: "150px",
    },
    {
      name: "Invoice Number",
      selector: (row) => row.vendorInvoiceNo,
      sortable: false,
      width: "180px",
    },
    {
      name: "Invoice Date",
      selector: (row) => row.vendorInvoiceDate || "--",
      sortable: false,
      width: "150px",
    },
    {
      name: "Invoice Value",
      selector: (row) => row.vendorTotalInvoiceValue || "--",
      sortable: false,
      width: "150px",
    },
    {
      name: "Currency",
      selector: (row) => row.currencyCode,
      sortable: false,
      width: "150px",
    },
    {
      name: "Shipping Type",
      cell: (row) => (
        <>
          <span> {capitalize(row.shippingType)} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Gatepass Number",
      selector: (row) => row?.gatepassNr || "--",
      sortable: false,
      width: "150px",
    },
    {
      name: "Gatepass Date",
      selector: (row) => row?.gatepassDate || "--",
      sortable: false,
      width: "150px",
    },
    {
      name: "Gatepass Time",
      selector: (row) => row?.gatepassTime || "--",
      sortable: false,
      width: "150px",
    },
    {
      name: "Cancelled ASN Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: false,
      width: "180px",
    },
    {
      name: "Cancelled ASN Date",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: false,
      width: "180px",
    },
    {
      name: "Cancelled ASN Remark",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: false,
      width: "200px",
    },
  ];

  // Invoice Historical Table
  const invoiceDataColumns = [
    {
      name: "Invoice Number",
      selector: (row) => row.invoiceNr,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageInvoice(row.invoiceNr)}
        >
          {row.invoiceNr}{" "}
        </button>
      ),
      sortable: false,
      width: "160px",
    },
    {
      name: "Collaboration",
      cell: (row) => (
        <>
          <span>
            <i className="bi bi-git iconTable"></i>
          </span>
          <span>
            <i className="bi bi-collection-play iconTable"></i>
          </span>
          <span>
            <i className="bi bi-stack iconTable"></i>
          </span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Status",
      selector: (row) => row.invoiceStatusHeader,
      cell: (row) => (
        <>
          <TableStatusField status={row.invoiceStatusHeader} />
        </>
      ),
      sortable: false,
      width: "180px",
    },
    // {
    //   name: "Status",
    //   cell: (row) => (
    //     <>
    //       <span className="bg-table-status bg-table-new-status">
    //         {row.invoiceStatusHeader}
    //       </span>
    //     </>
    //   ),
    //   width: "160px",
    // },
    {
      name: "Invoice Date",
      selector: (row) => row.vendorInvoiceDate,
      sortable: false,
      width: "130px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => InvoiceLineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: false,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },
    {
      name: "SAP Invoice",
      selector: (row) => row.sapinvoiceNr || "--",
      sortable: false,
      width: "150px",
    },
    {
      name: "Posted On",
      selector: (row) => row.sapPostedOn || "--",
      sortable: false,
      width: "130px",
    },
    {
      name: "Invoice Value",
      selector: (row) => row.vendorTotalInvoiceValue,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 fw-bold">{row.vendorTotalInvoiceValue}</p>
            <p className="m-0 p-0">{row.currencyCode}</p>
          </div>
        </>
      ),
      sortable: false,
      width: "150px",
    },
    // {
    //   name: "Currency",
    //   selector: (row) => row.currencyCode,
    //   sortable: false,
    //   width: "120px",
    // },
    {
      name: "Payment Terms",
      selector: (row) => row.paymentTerms,
      sortable: false,
      width: "150px",
    },
    {
      name: "Cancelled INV Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: false,
      width: "180px",
    },
    {
      name: "Cancelled INV Date",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: false,
      width: "180px",
    },
    {
      name: "Cancelled INV Remark",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: false,
      width: "200px",
    },
  ];

  //SES Historical Table
  const sesHistoryColInfo = [
    {
      name: "SES Number",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageSES(row.documentNumber)}
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: false,
      width: "150px",
    },

    {
      name: "Status",
      selector: (row) => row.sesStatusHeader,
      cell: (row) => (
        <>
          <TableStatusField status={row.sesStatusHeader} />
        </>
      ),
      sortable: false,
      width: "160px",
    },
    {
      name: "SES Date",
      selector: (row) => row.createdAt || "--",
      cell: (row) => (
        <>
          <span>{formatDateWithAMPM(row.createdAt)}</span>
        </>
      ),
      sortable: false,
      width: "150px",
    },
    {
      name: "Line Items",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => SESLineItemShowModal(row.items)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.items?.length} </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: false,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },

    /*  {
      name: "Currency",
      selector: (row) => row.currencyCode || "--",

      width: "150px",
    }, */

    /*   {
      name: "Delivery Note",
      selector: (row) => row.deliveryNoteNo || "--",
      sortable: false,
      width: "140px",
    }, */

    /*    {
      name: "Cancelled SES Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: false,
      width: "180px",
    }, */
    /*    {
      name: "Cancelled SES Date",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: false,
      width: "180px",
    }, */
    /*  {
      name: "Cancelled SES Remark",
      selector: (row) => row.purchasingDocumentItemNr,
      sortable: false,
      width: "200px",
    }, */
  ];

  //Two Way Table Col
  const twoWayColInfo = [
    {
      name: "PO Number",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageSES(row.documentNumber)}
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: false,
      width: "150px",
    },

    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: false,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },

    {
      name: "PO Item Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      cell: (row) => (
        <span className="bg-table-status bg-table-new-status w-50">
          {" "}
          {row.purchasingDocumentItemNr}
        </span>
      ),
      sortable: false,
      width: "150px",
    },
    /*   {
      name: "Date",
      selector: (row) => row.createdAt || "--",
      cell: (row) => (
        <>
          <span>{formatDate(row.createdAt)}</span>
        </>
      ),
      sortable: false,
      width: "130px",
    }, */
    {
      name: "Material",
      selector: (row) => row.materialCode,
      sortable: false,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
    },
    {
      name: "Qty",
      selector: (row) => row.purchaseQuantity,
      sortable: false,
      width: "100px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.purchaseQuantity} </p>
          <p className="m-0 p-0">{row.orderUnitOfMeasure} </p>
        </div>
      ),
    },

    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit,
      sortable: false,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.orderPriceUnit} </p>
          <p className="m-0 p-0 pt-1">{row.currencyCode} </p>
        </div>
      ),
    },

    {
      name: "Item Value",
      selector: (row) => row.netValue,
      sortable: false,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.netValue} </p>
          <p className="m-0 p-0 pt-1">{row.currencyCode} </p>
        </div>
      ),
    },

    {
      name: "INV",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              threeTwoItemShowModal(
                row.InvoiceRegister,
                "Invoice Register",
                threeInvoiceRegisterCols,
              )
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.InvoiceRegister?.length} </span>
        </>
      ),
      width: "100px",
    },

    {
      name: "INV Qty",
      selector: (row) => row.invoiceQuantity || "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invoiceQuantity || "--"}
        </span>
      ),
      width: "100px",
    },
    {
      name: "INV Total",
      selector: (row) => row.invTotalPrice || "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invTotalPrice || "--"}
        </span>
      ),
      width: "100px",
    },

    {
      name: "INV Tax",
      selector: (row) => row.invItemTaxValue || "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invItemTaxValue || "--"}
        </span>
      ),
      width: "100px",
    },
    {
      name: "INV Gross",
      selector: (row) => row.invItemTotalValue || "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invItemTotalValue || "--"}
        </span>
      ),
      width: "100px",
    },
    {
      name: "INV Qty (Bal)",
      selector: (row) => row.invBalancePurchaseQuantity ?? "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invBalancePurchaseQuantity ?? "--"}
        </span>
      ),
      width: "130px",
    },
    // {
    //   name: "Status",
    //   selector: (row) => row.statusItem,
    //   cell: (row) => (
    //     <>
    //       <TableStatusField status={row.statusItem} />
    //     </>
    //   ),
    //   sortable: false,
    //   width: "160px",
    // },
    {
      name: "Status",
      selector: (row) => row.statusItem,
      cell: (row) => {
        const purchase = parseFloat(row?.purchaseQuantity);
        // const grn = parseFloat(row?.grnQuantity);
        const invoice = parseFloat(row?.invoiceQuantity);

        const isTwoWayMatch = purchase === invoice;

        return (
          <>
            {isTwoWayMatch ? (
              <span className="bg-table-status bg-table-success-status">
                2 Way-Match
              </span>
            ) : (
              <span className="bg-table-status bg-table-danger-status">
                Mismatch
              </span> // Or leave empty: <span></span>
            )}
            {/* <TableStatusField status={row.statusItem} /> */}
          </>
        );
      },
      sortable: false,
      width: "160px",
    },
  ];

  //Three Way Table Table
  const threeWayColInfo = [
    {
      name: "PO Number",
      selector: (row) => row.documentNumber,
      cell: (row) => (
        <button
          className="btnInfo"
          onClick={() => detailedPageSES(row.documentNumber)}
        >
          {row.documentNumber}{" "}
        </button>
      ),
      sortable: false,
      width: "150px",
    },
    {
      name: "Vendor",
      selector: (row) => row.vendorCode,
      sortable: false,
      width: "150px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.vendorCode} </p>
          <p className="m-0 p-0">{row.vendorName} </p>
        </div>
      ),
    },

    {
      name: "PO Item Nr",
      selector: (row) => row.purchasingDocumentItemNr,
      cell: (row) => (
        <span className="bg-table-status bg-table-new-status w-50">
          {" "}
          {row.purchasingDocumentItemNr}
        </span>
      ),
      sortable: false,
      width: "150px",
    },

    {
      name: "Material",
      selector: (row) => row.materialCode,
      sortable: false,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialDescription} </p>
        </div>
      ),
    },
    {
      name: "Qty",
      selector: (row) => row.purchaseQuantity,
      sortable: false,
      width: "100px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.purchaseQuantity} </p>
          <p className="m-0 p-0">{row.orderUnitOfMeasure} </p>
        </div>
      ),
    },
    {
      name: "Item Value",
      selector: (row) => row.netValue,
      sortable: false,
      width: "120px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 fw-bold">{row.netValue} </p>
          <p className="m-0 p-0">{row.currencyCode} </p>
        </div>
      ),
    },

    /*  {
      name: "SES Date",
      selector: (row) => row.createdAt || "--",
      cell: (row) => (
        <>
          <span>{formatDate(row.createdAt)}</span>
        </>
      ),
      sortable: false,
      width: "150px",
    }, */

    {
      name: "GRN",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              threeTwoItemShowModal(
                row.GoodsMovement,
                "Goods Movement",
                threeGoodsMovementCols,
              )
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.GoodsMovement?.length} </span>
        </>
      ),
      width: "100px",
    },
    {
      name: "INV",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() =>
              threeTwoItemShowModal(
                row.InvoiceRegister,
                "Invoice Register",
                threeInvoiceRegisterCols,
              )
            }
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon"> {row.InvoiceRegister?.length} </span>
        </>
      ),
      width: "100px",
    },

    {
      name: "GRN Qty",
      selector: (row) => row.grnQuantity || "--",
      cell: (row) => (
        <span className="fw-bold text-primary">{row.grnQuantity || "--"}</span>
      ),
      width: "130px",
    },
    {
      name: "GRN Total",
      selector: (row) => row.grnTotalPrice || "--",
      cell: (row) => (
        <span className="fw-bold text-primary">
          {row.grnTotalPrice || "--"}
        </span>
      ),
      width: "100px",
    },
    {
      name: "GRN Qty (Bal)",
      selector: (row) => row.grnBalancePurchaseQuantity ?? "--",
      cell: (row) => (
        <span className="fw-bold text-primary">
          {row.grnBalancePurchaseQuantity ?? "--"}
        </span>
      ),
      width: "120px",
    },
    {
      name: "INV Qty",
      selector: (row) => row.invoiceQuantity ?? "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invoiceQuantity ?? "--"}
        </span>
      ),
      width: "110px",
    },
    {
      name: "INV Total",
      selector: (row) => row.invTotalPrice || "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invTotalPrice || "--"}
        </span>
      ),
      width: "100px",
    },

    {
      name: "INV Tax",
      selector: (row) => row.invItemTaxValue || "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invItemTaxValue || "--"}
        </span>
      ),
      width: "100px",
    },
    {
      name: "INV Gross",
      selector: (row) => row.invItemTotalValue || "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invItemTotalValue || "--"}
        </span>
      ),
      width: "100px",
    },

    {
      name: "INV Qty (Bal)",
      selector: (row) => row.invBalancePurchaseQuantity ?? "--",
      cell: (row) => (
        <span className="fw-bold text-success">
          {row.invBalancePurchaseQuantity ?? "--"}
        </span>
      ),
      width: "130px",
    },
    // {
    //   name: "Status",
    //   selector: (row) => row.statusItem,
    //   cell: (row) => (
    //     <>
    //     {/* {(row?.purchaseQuantity === row?.grnQuantity === row?.invoiceQuantity) ?(<span> 3 Way-Match</span>):(<span></span>)

    //     } */}
    //     {row?.purchaseQuantity === row?.grnQuantity &&
    //   row?.grnQuantity === row?.invoiceQuantity ? (
    //     <span>3 Way-Match</span>
    //   ) : (
    //     <span> no match</span>
    //   )}

    //       {/* <TableStatusField status={row.statusItem} /> */}
    //     </>
    //   ),
    //   sortable: false,
    //   width: "160px",
    // },
    {
      name: "Status",
      selector: (row) => row.statusItem,
      cell: (row) => {
        const purchase = parseFloat(row?.purchaseQuantity);
        const grn = parseFloat(row?.grnQuantity);
        const invoice = parseFloat(row?.invoiceQuantity);

        const isThreeWayMatch = purchase === grn && grn === invoice;

        return (
          <>
            {isThreeWayMatch ? (
              <span className="bg-table-status bg-table-success-status">
                3 Way-Match
              </span>
            ) : (
              <span className="bg-table-status bg-table-danger-status">
                Mismatch
              </span> // Or leave empty: <span></span>
            )}
          </>
        );
      },
      sortable: false,
      width: "160px",
    },
  ];

  // Onclick on Table Header Button
  const handleAcknowledgeClick = async () => {
    let obj = {
      _id: getHeaderData?._id,
      purchasingDocumentNr: getHeaderData?.purchasingDocumentNr,
    };

    // if (getSelectedData.length > 0) {
    await ItemService.AcknowledgePO(obj).then((item) => {
      if (item?.status === 200) {
        toast.success(item?.message || "PO Acknowledged successfully", {
          duration: 3000,
          position: "top-right",
        });

        setDisabled(true);
        setToggleCleared(true);
        setSelectedData([]);

        let materialPO = {
          queryName: "getMaterialPO",
          module: "PO",
        };
        let servicePO = {
          queryName: "getServicePO",
          module: "PO",
        };
        let schedulingAgreement = {
          queryName: "getSchedulingAgreement",
          module: "PO",
        };

        if (getHeaderData.purchaseTypeCode === "MAT") {
          dispatch(getPurchaseOrder(materialPO));
        } else if (getHeaderData.purchaseTypeCode === "SER") {
          dispatch(getServicePO(servicePO));
        } else if (getHeaderData.purchaseTypeCode === "SA") {
          dispatch(getSchedulingAgreement(schedulingAgreement));
        }
      } else {
        console.log("PO Acknowledged Not successfully");

        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
  };

  // Load GRN Historical data on page load
  const loadGrnHistoricalData = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      purchasingDocumentNr: poNumber,
    };

    setLoading(true);
    await ItemService.getPOGrn(obj).then((item) => {
      // console.log(">> res! getPOGrn", item);
      if (item?.status === 200) {
        // toast.success(item?.message || "", {
        //   duration: 3000,
        //   position: "top-right",
        // });
        setGrnHistoricalData(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setLoading(false);
  };

  // Load ASN Historical data on page load
  const loadAsnHistoricalData = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      purchasingDocumentNr: poNumber,
    };

    setLoading(true);
    await ItemService.getPOAsn(obj).then((item) => {
      // console.log(">> res! getPOAsn", item);
      if (item?.status === 200) {
        // toast.success(item?.message || "", {
        //   duration: 3000,
        //   position: "top-right",
        // });
        setAsnHistoricalData(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setLoading(false);
  };

  // Load Invoice Historical data on page load
  const loadInvoiceHistoricalData = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      purchasingDocumentNr: poNumber,
    };

    setLoading(true);
    await ItemService.getPOInvoice(obj).then((item) => {
      // console.log(">> res! getPOInvoice", item);
      if (item?.status === 200) {
        // toast.success(item?.message || "", {
        //   duration: 3000,
        //   position: "top-right",
        // });
        setInvoiceHistoricalData(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setLoading(false);
  };

  // Load Ses Historical data on page load
  const loadSesHistoricalData = async () => {
    let obj = {
      page: 1,
      per_page: 10,
      purchasingDocumentNr: poNumber,
    };

    setLoading(true);
    await ItemService.getPOSes(obj).then((item) => {
      // console.log(">> res! getPOSes", item);
      if (item?.status === 200) {
        // toast.success(item?.message || "", {
        //   duration: 3000,
        //   position: "top-right",
        // });
        setSesHistoricalData(item.data);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setLoading(false);
  };

  //Selected from the Table
  const handleChange = ({ selectedRows }) => {
    setToggleCleared(false);
    setSelectedData(selectedRows);
    dispatch(addSelectedItemList(selectedRows));
    // if (selectedRows.length > 0) {
    //   setDisabled(false);
    // } else {
    //   setDisabled(true);
    // }
  };

  //Create ASN
  const createASN = () => {
    navigate(Constants.POCOLLABRATION_ASN_CREATION);
  };

  //Create SA ASN
  const createSAASN = () => {
    navigate(Constants.POCOLLABRATION_SA_ASN_CREATION);
  };

  //Create GRN
  const createGRN = () => {
    let obj = {
      asnNumber: "",
      subTransactionActivity: "PO",
    };
    dispatch(addSubTransactionActivity(obj));
    navigate(CustomerConstants.CUSTOMER_V5_MR_POCOLLABRATION_GRN_CREATION);
  };

  //Create SES
  const createSES = () => {
    let obj = {
      asnNumber: "",
      subTransactionActivity: "PO",
    };
    dispatch(addSubTransactionActivity(obj));
    navigate(CustomerConstants.CUSTOMER_V5_MR_POCOLLABRATION_SES_CREATION);
    // navigate(Constants.POCOLLABRATION_SES_CREATION);
  };

  //Create Invoice
  // const createInvoice = () => {
  //   navigate(Constants.POCOLLABRATION_INVOICE_CREATION);
  // };

  // //Create Invoice SES
  // const createInvoiceSES = () => {
  //   navigate(Constants.POCOLLABRATION_INVOICE_CREATION_SES);
  // };

  useEffect(() => {
    if (
      workflow?.workflow_record?.businessComponentId ===
      getConstantVar?.POBusinessComponentId
    ) {
      localStorage.setItem("menu", workflow?.page);
      localStorage.setItem("submenu", "-");
    } else {
      //console.log(">> getHeaderData", getHeaderData);
      if (getHeaderData.purchaseTypeCode === "MAT") {
        localStorage.setItem("menu", "Purchasing");
        localStorage.setItem("submenu", "Purchase Order");
      } else if (getHeaderData.purchaseTypeCode === "SER") {
        localStorage.setItem("menu", "Purchasing");
        localStorage.setItem("submenu", "Service PO");
      } else if (getHeaderData.purchaseTypeCode === "SA") {
        localStorage.setItem("menu", "Purchasing");
        localStorage.setItem("submenu", "Scheduling Agreement");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const showServiceItemTable = (serviceData, itemNr) => {
    setItemNr(itemNr);
    setServiceData(serviceData);
    setServiceTableStatus(true);
  };
  const hide = () => {
    setServiceTableStatus(false);
  };

  const [itemTableData, setItemTableData] = useState([]);

  // console.log(">>itemTableData", itemTableData.length);
  //load SES data on page load
  const loadInitalPageData = async () => {
    setLoading(true);

    let obj = {
      purchasingDocumentNr: poNumber,
    };
    await ItemService?.createSES(obj).then((item) => {
      // console.log(">> res! createSES", item);
      if (item?.status === 200) {
        const updatedItemData = item?.data.map((obj, index) => ({
          ...obj,
          sesItemNr: index + 1,
          local_id: index + 1,
          originalBalancePurchaseQuantity: obj.invBalancePurchaseQuantity,
          invItemTaxValue: 0,
          purchasingDocumentNr: poNumber,
        }));

        setItemTableData(updatedItemData);
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });

    setLoading(false);
  };

  useEffect(() => {
    loadInitalPageData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poNumber]);

  const [getGrnSesAllowed, setGrnSesAllowed] = useState();
  useEffect(() => {
    if (userData?.data?.roles) {
      const allowedRoles = ["STORE", "SALES-ADMIN"];

      const isAllowed = userData.data.roles.some((r) =>
        allowedRoles.includes(r.roleId),
      );

      setGrnSesAllowed(isAllowed);
    }
  }, [userData]);

  //version

  const remarkLineItemColInfo = [
    {
      name: "Remarks",
      cell: (row) => <span>{row?.remark || ""} </span>,
      width: "180px",
    },
    {
      name: "Version",
      cell: (row) => <span>{row?.version || ""} </span>,
      width: "180px",
    },
    {
      name: "Status",
      cell: (row) => (
        <span>
          {" "}
          <TableStatusField status={row?.status} />
        </span>
      ),
      width: "180px",
    },
  ];
  const remarkItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(remarkLineItemColInfo);
    setModalTitle("PO Remarks / Version");
    setItemLevelModalShow(true);
  };
  const [userRoleData, serUserRoleData] = useState();
  useEffect(() => {
    if (userData?.data?.roles) {
      const allowedRoles = ["PROC-MNGR"];
      const isAllowed = userData?.data?.roles.some((r) =>
        allowedRoles.includes(r.roleId),
      );
      serUserRoleData(isAllowed);
    }
  }, [userData]);

  //handle Update
  const handleUpdate = async (newRemarks) => {
    const toastId = toast.loading("Loading...", {
      position: "top-right",
    });
    // console.log(">>updateRemarks", getHeaderData.updateRemarks);
    let remarks = [...getHeaderData.updateRemarks];

    // if (remarks.length > 0) {
    //   let lastIndex = remarks.length - 1;
    //   let lastRemark = remarks[lastIndex];

    //   if (!lastRemark.status) {
    //     remarks[lastIndex] = {
    //       ...lastRemark,
    //       status: "PO Approved", //not updatiing
    //     };
    //   }
    // }

    if (remarks.length > 0) {
      let lastIndex = remarks.length - 1;
      remarks[lastIndex] = {
        ...remarks[lastIndex],
        status: "PO Approved",
      };
    }

    let obj = {
      documentNumber: poNumber,
      purchasingDocumentNr: poNumber,
      statusHeader: "PO Approved", // is updating
      updateRemarks: remarks,
    };

    // console.log(">>obj", obj);

    setDisabled(true);
    await CustomerService.updatePODocs(obj).then((item) => {
      // console.log(">>item", item);
      if (item?.status === 200) {
        // modalData.successMsg = item?.message;
        // setModalInfo(modalData);
        // onSuccessfullyRegistered();

        let materialPO = {
          queryName: "getMaterialPO",
          module: "PO",
        };
        let servicePO = {
          queryName: "getServicePO",
          module: "PO",
        };
        let schedulingAgreement = {
          queryName: "getSchedulingAgreement",
          module: "PO",
        };

        if (getHeaderData.purchaseTypeCode === "MAT") {
          dispatch(getPurchaseOrder(materialPO));
          navigate(CustomerConstants?.CUSTOMER_V5_PURCHASE_ORDER_LIST);
        } else if (getHeaderData.purchaseTypeCode === "SER") {
          navigate(
            CustomerConstants?.CUSTOMER_V5_MR_POCOLLABRATION_SERVICE_PURCHASE_ORDER_LIST,
          );
          dispatch(getServicePO(servicePO));
        } else if (getHeaderData.purchaseTypeCode === "SA") {
          dispatch(getSchedulingAgreement(schedulingAgreement));
        }
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    toast.dismiss(toastId);
    setDisabled(false);
  };
  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const [showBarcodeModal, setShowBarcodeModal] = useState(false);
  const [selectedBarcodeRow, setSelectedBarcodeRow] = useState(null);

  const handleViewBarcode = (row) => {
    setSelectedBarcodeRow(row);
    setShowBarcodeModal(true);
  };

  const handleCloseBarcodeModal = () => {
    setShowBarcodeModal(false);
    setSelectedBarcodeRow(null);
  };

  const qltyColumns = [
    {
      name: "GRN Item Nr",
      selector: (row) => row.grnItemNr,
      sortable: false,
      width: "130px",
    },
    {
      name: "PO Item",
      selector: (row) => row.purchasingDocumentItemNr,
      width: "100px",
    },
    {
      name: "Qulity Number",
      selector: (row) => row.qualityCheckNr,
      width: "140px",
    },

    ...(getHeaderData?.purchaseTypeCode?.trim() === "SER"
      ? [
          {
            name: "Schedule Nr",
            selector: (row) => row.scheduleNr,
            width: "150px",
          },
        ]
      : []),

    {
      name: "Material",
      cell: (row) => (
        <div>
          <div>
            <strong>{row.materialCode}</strong>
          </div>
          <div className="text-muted">{row.materialDescription}</div>
        </div>
      ),
      width: "200px",
    },
    {
      name: "UOM / PO Qty",
      cell: (row) => (
        <div className="d-flex flex-column">
          <span>
            {row.orderUnitOfMeasure}
            <span className="fw fw-bold ms-2">{row.purchaseQuantity}</span>
          </span>
        </div>
      ),
      width: "160px",
    },
    {
      name: "GRN Qty",
      selector: (row) => row.grnQuantity,
      width: "120px",
    },

    {
      name: "Barcode",
      width: "160px",
      cell: (row) => {
        const hasBarcode =
          row.barcodeInfo &&
          Array.isArray(row.barcodeInfo) &&
          row.barcodeInfo.length > 0;

        const grnQty = row.grnQuantity;

        // If GRN Qty is empty, 0, or null → don't show button
        if (!grnQty || grnQty === 0) {
          return null;
        }

        return hasBarcode ? (
          <button
            className="btn btn-sm btn-success"
            onClick={() => handleViewBarcode(row)}
          >
            View Barcode
          </button>
        ) : (
          <span
          // className="btn btn-sm btn-primary"
          // onClick={() => handleCreateBarcode(row)}
          >
            --
          </span>
        );
      },
    },

    {
      name: "Balance Qty",
      selector: (row) => row.grnBalancePurchaseQuantity,
      width: "150px",
    },
    // {
    //   name: "Storage Location",
    //   selector: (row) => row.storagePlace,
    //   width: "180px",
    // },
  ];

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Purchase Order Details:{" "}
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {poNumber}
              </span>
              <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                {getHeaderData.purchaseType}
              </span>
              <span>
                {getHeaderData?.statusHeader === "New" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : getHeaderData?.statusHeader === "In Release" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : getHeaderData?.statusHeader === "Acknowledged" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : getHeaderData?.statusHeader === "Cancelled" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : getHeaderData?.statusHeader === "PO Approved" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : getHeaderData?.statusHeader === "PO Revised" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : getHeaderData?.statusHeader === "Rejected" ? (
                  <span className="bg-table-status bg-table-danger-status headerStatusDetailedPage">
                    {getHeaderData?.statusHeader}
                  </span>
                ) : (
                  getHeaderData?.statusHeader
                )}
              </span>
              {/*   <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {getHeaderData?.matchDesc}
              </span> */}
            </h2>
            <p className="subText">Purchase Order Information </p>
            <hr />

            {/* Workflow Component */}
            {/* <WorkflowApproveReject workflowData={workflow} /> */}

            <Row>
              <Col sm={12} md={10} lg={10}>
                <WorkflowApproveReject workflowData={updatedWorkflowRecord} />
              </Col>
              {userRoleData && getHeaderData?.statusHeader === "PO Revised" && (
                <Col sm={2} md={2} lg={2}>
                  <button
                    className="btn btnInfo"
                    disabled={disabled}
                    onClick={handleUpdate}
                  >
                    Approve
                  </button>
                </Col>
              )}
            </Row>

            {/* Header Details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">HR</span>
                    </Col>
                    <Col xs={12} md={5} lg={6}>
                      <span className="headerTitle">Header Details</span>
                      <span className="subHeaderTitle"> </span>
                    </Col>

                    {!workflow?.workflow_record?.businessComponentId &&
                      userInfo?.roles?.length > 0 &&
                      getGrnSesAllowed &&
                      getHeaderData.process === "GRN" &&
                      getHeaderData?.statusHeader === "New" && (
                        <>
                          <Col
                            xs={{ span: "2", offset: "2" }}
                            md={{ span: "2", offset: "2" }}
                            lg={{ span: "2", offset: "2" }}
                            className=""
                          >
                            <button
                              className="btnTable"
                              onClick={() => createGRN()}
                            >
                              <i className="bi bi-truck"></i> Create Goods
                              Receipt
                            </button>
                          </Col>
                        </>
                      )}

                    {!workflow?.workflow_record?.businessComponentId &&
                      userInfo?.roles?.length > 0 &&
                      (userInfo?.roles[0].roleId === "STORE"
                        ? true
                        : false) && (
                        <>
                          {/* {getHeaderData?.statusHeader === "Acknowledged" && ( */}
                          <Col
                            xs={12}
                            md={8}
                            lg={8}
                            className="headerButtonAlign"
                          >
                            {config.createASN &&
                              getHeaderData.purchaseTypeCode === "SA" && (
                                <Col xs={4} md={2} lg={2} className="">
                                  <button
                                    className="btnTable"
                                    onClick={() => createSAASN()}
                                  >
                                    <i className="bi bi-calendar-check"></i>{" "}
                                    Create ASN
                                  </button>
                                </Col>
                              )}

                            {config.createGRN &&
                              getHeaderData.purchaseTypeCode === "MAT" && (
                                <>
                                  {getHeaderData.process === "ASN" && (
                                    <Col xs={4} md={2} lg={2} className="">
                                      <button
                                        className="btnTable"
                                        onClick={() => createASN()}
                                      >
                                        <i className="bi bi-calendar-check"></i>{" "}
                                        Create ASN
                                      </button>
                                    </Col>
                                  )}

                                  {/*    { getHeaderData.process === "GRN" && (
                                    <Col xs={4} md={2} lg={2} className="">
                                      <button
                                        className="btnTable"
                                        onClick={() => createGRN()}
                                      >
                                        <i className="bi bi-truck"></i> Create
                                        Goods Receipt
                                      </button>
                                    </Col>
                                  )} */}
                                </>
                              )}

                            {/*   {getGrnSesAllowed && config.createSES &&
                              getHeaderData.purchaseTypeCode === "SER" && (
                                <Col xs={4} md={2} lg={2} className="">
                                  <button
                                    className="btnTable"
                                    onClick={() => createSES()}
                                  >
                                    <i className="bi bi-file-spreadsheet"></i>{" "}
                                    Create SES
                                  </button>
                                </Col>
                              )} */}

                            {/* {config.createInvoice &&
                                getHeaderData.purchaseTypeCode === "MAT" && (
                                  <>
                                    {getHeaderData.process === "GRN" && (
                                      <Col xs={4} md={2} lg={2} className="">
                                        <button
                                          className="btnTable"
                                          onClick={() => createInvoice()}
                                        >
                                          <i className="bi bi-currency-dollar"></i>{" "}
                                          Create Invoice
                                        </button>
                                      </Col>
                                    )}
                                  </>
                                )} */}

                            {/* {getHeaderData.purchaseTypeCode === "SER" && ( */}
                            {/* <Col xs={4} md={2} lg={2} className="">
                                  <button
                                    className="btnTable"
                                    onClick={() => createInvoiceSES()}
                                  >
                                    <i className="bi bi-currency-dollar"></i>{" "}
                                    Create Invoice
                                  </button>
                                </Col> */}
                            {/* )} */}
                          </Col>
                          {/* )}  */}
                        </>
                      )}

                    {config?.createSES &&
                      getHeaderData.purchaseTypeCode === "SER" &&
                      getGrnSesAllowed &&
                      getHeaderData?.statusHeader === "New" &&
                      itemTableData.length !== 0 && (
                        <Col
                          xs={{ span: "2", offset: "2" }}
                          md={{ span: "2", offset: "2" }}
                          lg={{ span: "2", offset: "2" }}
                          className=""
                        >
                          <button
                            className="btnTable"
                            onClick={() => createSES()}
                          >
                            <i className="bi bi-file-spreadsheet"></i> Create
                            SES
                          </button>
                        </Col>
                      )}
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Document Number"
                          name="purchasingDocumentNr"
                          placeholder=""
                          value={getHeaderData?.purchasingDocumentNr || ""}
                          disabled={true}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Status"
                          name="statusHeader"
                          placeholder=""
                          value={getHeaderData?.statusHeader || ""}
                          disabled={true}
                        />
                      </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Document Date"
                          name="purchasingDocumentDate"
                          placeholder=""
                          value={getHeaderData?.purchasingDocumentDate || ""}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Purchase Organization"
                          name="purchasingOrg"
                          placeholder=""
                          value={getHeaderData?.purchasingOrg || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Company Code "
                          name="companyCode"
                          id="companyCode"
                          value={getHeaderData?.companyCode}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Purchse Type"
                          name="purchasingRemark"
                          placeholder=""
                          value={getHeaderData?.purchaseType || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Purchase Order Type"
                          name="purchaseOrderType"
                          placeholder=""
                          value={getHeaderData?.purchaseOrderType || ""}
                          disabled={true}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Purchase Group"
                          name="purchasingGroup"
                          placeholder=""
                          value={getHeaderData?.purchasingGroup || ""}
                          disabled={true}
                        />
                      </Col> */}
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Open Value"
                          name="openValue"
                          placeholder=""
                          value={getHeaderData?.openValue || ""}
                          disabled={true}
                        />
                      </Col> */}
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Delivered Value"
                          name="deliverdValue"
                          placeholder=""
                          value={getHeaderData?.deliverdValue || ""}
                          disabled={true}
                        />
                      </Col> */}
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Delivered Status"
                          name="deliveredStatus"
                          placeholder=""
                          value={getHeaderData?.deliveredStatus || ""}
                          disabled={true}
                        />
                      </Col> */}
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Invoiced Value"
                          name="invoicedValue"
                          placeholder=""
                          value={getHeaderData?.invoicedValue || ""}
                          disabled={true}
                        />
                      </Col> */}
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Invoiced Status"
                          name="invoicedStatus"
                          placeholder=""
                          value={getHeaderData?.invoicedStatus || ""}
                          disabled={true}
                        />
                      </Col> */}
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Paid Value"
                          name="paidValue"
                          placeholder=""
                          value={getHeaderData?.paidValue || ""}
                          disabled={true}
                        />
                      </Col> */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Vendor Code"
                          name="vendorCode"
                          placeholder=""
                          value={getHeaderData?.vendorCode || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Vendor Name"
                          name="vendorName"
                          placeholder=""
                          value={getHeaderData?.vendorName || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          id="vendorAddress"
                          className="inputBox"
                          label="Vendor Address"
                          name="vendorAddress"
                          placeholder=""
                          value={getHeaderData?.vendorAddress || ""}
                          disabled={true}
                          // onChange={onInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="vendorEmail"
                          className="inputBox"
                          label="Vendor Email"
                          name="vendorEmail"
                          placeholder=""
                          value={getHeaderData?.vendorEmail || ""}
                          disabled={true}
                          // onChange={onInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="vendorMobileNo"
                          className="inputBox"
                          label="Vendor Mobile"
                          name="vendorMobileNo"
                          placeholder=""
                          value={getHeaderData?.vendorMobileNo || ""}
                          disabled={true}
                          // onChange={onInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="vendorGSTNo"
                          className="inputBox"
                          label="Vendor GST"
                          name="vendorGSTNo"
                          placeholder=""
                          value={getHeaderData?.vendorGSTNo || ""}
                          disabled={true}
                          // onChange={onInputChange}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Payment Terms"
                          name="paymentTerms"
                          placeholder=""
                          value={getHeaderData?.paymentTerms || ""}
                          disabled={true}
                        />
                      </Col>
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Inco Terms"
                          name="incoTerms"
                          placeholder=""
                          value={getHeaderData?.incoTerms || ""}
                          disabled={true}
                        />
                      </Col> */}

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Total Item Amount"
                          name="purchasingDocumentValue"
                          placeholder=""
                          value={currencyFormat(
                            Number(
                              getHeaderData?.purchasingDocumentItemTotalValue,
                            ).toFixed(2),
                          )}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Total GST Amount"
                          name="purchasingDocumentValue"
                          placeholder=""
                          value={currencyFormat(
                            Number(
                              getHeaderData?.purchasingDocumentTaxTotalValue,
                            ).toFixed(2),
                          )}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Total Purchase Value"
                          name="purchasingDocumentValue"
                          placeholder=""
                          value={currencyFormat(
                            Number(
                              getHeaderData?.purchasingDocumentValue,
                            ).toFixed(2),
                          )}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Currency"
                          name="currencyDesc"
                          placeholder=""
                          value={getHeaderData?.currencyDesc}
                          disabled={true}
                        />
                      </Col>

                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <TextAreaField
                          id="purchasingRemark"
                          className="inputBox"
                          label="Purchasing Info"
                          name="purchasingRemark"
                          placeholder=""
                          value={getHeaderData.purchasingRemark || ""}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          id="version"
                          className="inputBox"
                          label="Version"
                          name="version"
                          placeholder=""
                          value={getHeaderData?.version || ""}
                          disabled={true}
                        />
                      </Col>
                      {getHeaderData?.purchaseTypeCode === "MAT" && (
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <span className="fw-medium text-black">
                            PO Remarks / Version
                          </span>
                          <div>
                            <span
                              style={{ marginLeft: "12px" }}
                              onClick={() =>
                                remarkItemShowModal(getHeaderData.updateRemarks)
                              }
                            >
                              <i className="bi bi-calendar2-week iconTable"></i>
                            </span>
                            <span className="suppliersIcon">
                              {getHeaderData?.updateRemarks?.length > 0
                                ? `${getHeaderData.updateRemarks.length}/${getHeaderData?.version}`
                                : `0/${getHeaderData?.version}`}
                            </span>
                          </div>
                        </Col>
                      )}
                      <Row>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex align-items-center"
                        >
                          <input
                            id="deliveryLoaction"
                            type="checkbox"
                            className="inputBox"
                            label="Delivery Location"
                            name="deliveryLoaction"
                            checked={getHeaderData?.deliveryLoaction ?? true}
                            disabled={true}
                          />
                          <label
                            htmlFor="deliveryLoaction"
                            className="fw-medium mx-2"
                            style={{ cursor: "pointer" }}
                          >
                            Delivery Location
                          </label>
                        </Col>
                      </Row>
                      {getHeaderData?.deliveryLoaction && (
                        <Row>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              id="addressDl"
                              className="inputBox"
                              label="Address"
                              name="addressDl"
                              placeholder=""
                              value={getHeaderData?.addressDl}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="mobileNoDl"
                              className="inputBox"
                              label="Mobile No"
                              name="mobileNoDl"
                              placeholder=""
                              value={getHeaderData?.mobileNoDl}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="gstInDl"
                              className="inputBox"
                              label="GSTIN"
                              name="gstInDl"
                              placeholder=""
                              value={getHeaderData?.gstInDl}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              id="emailDl"
                              className="inputBox"
                              label="Email"
                              name="emailDl"
                              placeholder=""
                              value={getHeaderData?.emailDl}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                      )}
                      {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding mt-4 pt-3"
                      >
                        <div>
                          <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
                            Header Text
                          </label>
                          <span
                            style={{ marginLeft: "15px" }}
                            onClick={() =>
                              headerTextShowModal(getHeaderData?.headerTextData)
                            }
                          >
                            <i className="bi bi-calendar2-week iconTable"></i>
                          </span>
                          <span className="suppliersIcon">
                            {" "}
                            {getHeaderData?.headerTextData?.length || 0}{" "}
                          </span>
                        </div>
                      </Col> */}

                      {/* PO Approval Section */}
                      {getHeaderData?.triggerWorkflow && (
                        <>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding d-flex align-items-center"
                            >
                              <input
                                id="triggerWorkflowDisplay"
                                type="checkbox"
                                className="inputBox"
                                name="triggerWorkflow"
                                checked={getHeaderData?.triggerWorkflow}
                                disabled={true}
                              />
                              <label
                                htmlFor="triggerWorkflowDisplay"
                                className="fw-medium mx-2"
                                style={{ cursor: "pointer" }}
                              >
                                PO Approval
                              </label>
                            </Col>
                          </Row>
                          <Row>
                            <Col
                              xs={12}
                              md={4}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="How many approval level is required?"
                                name="approverLevel"
                                placeholder=""
                                value={getHeaderData?.approverLevel || ""}
                                disabled={true}
                              />
                            </Col>
                          </Row>
                          {/* Display Approver Levels */}
                          {getHeaderData?.triggerWorkflow && (
                            <Row>
                              {[1, 2, 3, 4, 5].map((i) => (
                                <Col
                                  key={i}
                                  xs={12}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label={`Approver Level ${i}`}
                                    name={`approverUserId${i}`}
                                    placeholder=""
                                    value={
                                      getHeaderData?.[
                                        `approverUserId${i}Desc`
                                      ] ||
                                      getHeaderData?.[`approverUserId${i}`] ||
                                      ""
                                    }
                                    disabled={true}
                                  />
                                </Col>
                              ))}
                            </Row>
                          )}
                        </>
                      )}
                      {/* End PO Approval Section */}
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Line Items 2*/}
            {sortedQualityCheckItems && sortedQualityCheckItems.length > 0 && (
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible2
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">QD</span>
                      </Col>
                      <Col xs={12} md={6} lg={7}>
                        <span className="headerTitle">Quality Details</span>
                        {/* <span className="subHeaderTitle">
                        Material/ Service Details
                      </span> */}
                      </Col>

                      <Col xs={2} md={1} lg={1} className="">
                        {/* <SourcingCommonFilter /> */}
                      </Col>
                    </Row>
                  </h2>
                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible2 ? "visible" : ""
                    }`}

                    // aria-labelledby="headingOne"
                    // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            // title=""
                            columns={qltyColumns}
                            // data={qualityCheckItems}
                            data={sortedQualityCheckItems}
                            progressPending={loading}
                            pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                            paginationRowsPerPageOptions={
                              Constants.ROW_PER_PAGE
                            }
                          />
                        </Col>
                        {showBarcodeModal && selectedBarcodeRow && (
                          <Modal
                            show={showBarcodeModal}
                            onHide={handleCloseBarcodeModal}
                            size="lg"
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>Barcode Details</Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                              {/* LINE ITEM DETAILS */}
                              <div className="mb-3">
                                <p>
                                  <strong>Material Code:</strong>{" "}
                                  {selectedBarcodeRow.materialCode}
                                </p>
                                <p>
                                  <strong>Description:</strong>{" "}
                                  {selectedBarcodeRow.materialDescription}
                                </p>
                                <p>
                                  <strong>GRN Item Nr:</strong>{" "}
                                  {selectedBarcodeRow.grnItemNr}
                                </p>
                                <p>
                                  <strong>PO Item:</strong>{" "}
                                  {selectedBarcodeRow.purchasingDocumentItemNr}
                                </p>
                                <p>
                                  <strong>Quantity:</strong>{" "}
                                  {selectedBarcodeRow.grnQuantity}
                                </p>
                              </div>

                              <hr />

                              {/* BARCODE INFO TABLE */}
                              <table className="table table-bordered">
                                <thead>
                                  <tr>
                                    <th>Barcode No</th>
                                    <th>Status</th>
                                    <th>Created On</th>
                                    <th>Godown</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {selectedBarcodeRow.barcodeInfo.map(
                                    (barcode, index) => (
                                      <tr key={index}>
                                        <td>{barcode.barcodeNr}</td>
                                        <td>{barcode.status}</td>
                                        <td>{barcode.createdOn}</td>
                                        <td>{barcode.godown}</td>
                                      </tr>
                                    ),
                                  )}
                                </tbody>
                              </table>
                            </Modal.Body>

                            <Modal.Footer>
                              <button
                                className="btn btn-secondary"
                                onClick={handleCloseBarcodeModal}
                              >
                                Close
                              </button>
                            </Modal.Footer>
                          </Modal>
                        )}
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Line Itemss */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LI</span>
                    </Col>
                    <Col xs={12} md={3} lg={3}>
                      <span className="headerTitle">Line Items</span>
                      <span className="subHeaderTitle"> </span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      {userInfo?.roles?.length > 0 &&
                        (userInfo?.roles[0].roleId === "VENDOR"
                          ? true
                          : false) &&
                        getHeaderData?.statusHeader !== "Acknowledged" && (
                          <>
                            <Col xs={4} md={2} lg={2} className="">
                              <button
                                className="btnTable"
                                onClick={() => handleAcknowledgeClick()}
                                disabled={disabled}
                              >
                                <i className="bi bi-check-circle"></i>{" "}
                                Acknowledge
                              </button>
                            </Col>
                          </>
                        )}

                      <Col xs={2} md={2} lg={2} className="">
                        {getServiceTableStatus ? (
                          <button className="btn btn-danger" onClick={hide}>
                            <i className="bi bi-eye-slash-fill"></i> Hide
                            Serivces
                          </button>
                        ) : (
                          " "
                        )}
                      </Col>
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={
                            getHeaderData.purchaseTypeCode === "MAT"
                              ? columns
                              : getHeaderData.purchaseTypeCode === "SER"
                                ? columnsService
                                : getHeaderData.purchaseTypeCode === "SA"
                                  ? columnsSchedule
                                  : columns
                          }
                          data={data}
                          progressPending={loading}
                          pagination
                          // paginationServer
                          // paginationTotalRows={totalRows}
                          // onChangeRowsPerPage={handlePerRowsChange}
                          // onChangePage={handlePageChange}
                          selectableRows
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          onSelectedRowsChange={handleChange}
                          clearSelectedRows={toggleCleared}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Service Itemss */}
            {getServiceTableStatus && (
              <div
                ref={divRef}
                className="accordion mb-4"
                id="accordionExample"
              >
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible2
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">LI</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">
                          {getHeaderData.purchaseTypeCode === "SER"
                            ? `Services - PO Item: ${getItemNr}`
                            : getHeaderData.purchaseTypeCode === "SA"
                              ? `Schedules - SA Item: ${getItemNr}`
                              : ""}
                        </span>
                        <span className="subHeaderTitle"> </span>
                      </Col>

                      {/* <Col xs={2} md={1} lg={1} className="">
                        <div className="filter">
                          <span
                            className="icon hide headerIcon "
                            data-bs-toggle="dropdown"
                            aria-expanded="true"
                            onClick={()=>hide()}
                          >
                            <i className="bi bi-x-circle"></i>
                          </span>
                        </div>
                      </Col> */}
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible2 ? "visible" : ""
                    }`}
                    // aria-labelledby="headingOne"
                    // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            title=""
                            columns={
                              getHeaderData.purchaseTypeCode === "SER"
                                ? serviceColInfo
                                : getHeaderData.purchaseTypeCode === "SA"
                                  ? scheduleColInfo
                                  : ""
                            }
                            data={getServiceData}
                            progressPending={loading}
                            pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                            paginationRowsPerPageOptions={
                              Constants.ROW_PER_PAGE
                            }
                            onSelectedRowsChange={handleChange}
                            clearSelectedRows={toggleCleared}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Historical ASN List */}
            {getAsnHistoricalData.length > 0 && (
              <>
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible4
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility4}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">SL</span>
                        </Col>
                        <Col xs={5} md={8} lg={8}>
                          <span className="headerTitle">Historical ASN</span>
                          <span className="subHeaderTitle">
                            View of ASN List{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col> */}
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible4 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={asnHistoryColInfo}
                              data={getAsnHistoricalData}
                              progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Historical Goods Received Note List */}
            {getGrnHistoricalData.length > 0 && (
              <>
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible3
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility3}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">HS</span>
                        </Col>
                        <Col xs={12} md={8} lg={8}>
                          <span className="headerTitle">Historical GRN</span>
                          <span className="subHeaderTitle">
                            View of Goods Received Note List{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col> */}
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible3 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={grnHistoryColInfo}
                              data={getGrnHistoricalData}
                              progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Historical Invoice List */}
            {getInvoiceHistoricalData.length > 0 && (
              <>
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible3
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility3}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">SL</span>
                        </Col>
                        <Col xs={12} md={8} lg={8}>
                          <span className="headerTitle">
                            Historical Invoice
                          </span>
                          <span className="subHeaderTitle">
                            View of Invoice List{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col> */}
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible3 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={invoiceDataColumns}
                              data={getInvoiceHistoricalData}
                              progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Historical SES List */}
            {getSesHistoricalData.length > 0 && (
              <>
                <div className="accordion mb-4" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header">
                      <Row className="accordion-button">
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-left arrowBtn"
                        >
                          <i
                            className={`bi ${
                              isCardVisible3
                                ? "bi-chevron-right"
                                : "bi-chevron-down"
                            }`}
                            onClick={toggleCardVisibility3}
                          ></i>
                        </Col>
                        <Col
                          xs={1}
                          md={1}
                          lg={1}
                          className="text-center logoBtn"
                        >
                          <span className="iconLogo">SL</span>
                        </Col>
                        <Col xs={12} md={8} lg={8}>
                          <span className="headerTitle">Historical SES</span>
                          <span className="subHeaderTitle">
                            View of SES List{" "}
                          </span>
                        </Col>

                        {/* <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col> */}
                      </Row>
                    </h2>

                    <div
                      // id="acc"
                      className={`accordion-collapse collapse show ${
                        isCardVisible3 ? "visible" : ""
                      }`}
                      // aria-labelledby="headingOne"
                      // data-bs-parent="#accordionExample"
                    >
                      <div className="accordion-body">
                        <Row>
                          <Col xs={12} md={12} lg={12}>
                            <DataTable
                              title=""
                              columns={sesHistoryColInfo}
                              data={getSesHistoricalData}
                              progressPending={loading}
                              paginationRowsPerPageOptions={
                                Constants.ROW_PER_PAGE
                              }
                              pagination
                              // paginationServer
                              // paginationTotalRows={totalRows}
                              // onChangeRowsPerPage={handlePerRowsChange}
                              // onChangePage={handlePageChange}
                              selectableRows
                            />
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {getHeaderData?.statusHeader === "Acknowledged" &&
              (userData?.data?.category === "VENDOR" ? (
                ""
              ) : (
                <>
                  {(getHeaderData?.matchCode === "M1" ||
                    getHeaderData?.matchCode === "M3") && (
                    <>
                      {/* Two-way matching - PO /Invoice */}
                      <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${
                                    isCardVisible5
                                      ? "bi-chevron-right"
                                      : "bi-chevron-down"
                                  }`}
                                  onClick={toggleCardVisibility5}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">TW</span>
                              </Col>
                              <Col xs={12} md={8} lg={8}>
                                <span className="headerTitle">
                                  Two-Way Matching - Purchase Order /Invoice
                                </span>
                                <span className="subHeaderTitle">
                                  View of Two Way List{" "}
                                </span>
                              </Col>

                              {/* <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col> */}
                            </Row>
                          </h2>

                          <div
                            // id="acc"
                            className={`accordion-collapse collapse show ${
                              isCardVisible5 ? "visible" : ""
                            }`}
                            // aria-labelledby="headingOne"
                            // data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <Row>
                                <Col xs={12} md={12} lg={12}>
                                  <DataTable
                                    title=""
                                    columns={twoWayColInfo}
                                    data={getThreeWayMatch}
                                    progressPending={loading}
                                    paginationRowsPerPageOptions={
                                      Constants.ROW_PER_PAGE
                                    }
                                    pagination
                                    // paginationServer
                                    // paginationTotalRows={totalRows}
                                    // onChangeRowsPerPage={handlePerRowsChange}
                                    // onChangePage={handlePageChange}
                                    selectableRows
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {(getHeaderData?.matchCode === "M2" ||
                    getHeaderData?.matchCode === "M3") && (
                    <>
                      {/* Three-way matching - PO /Invoice /GRN  */}
                      <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${
                                    isCardVisible6
                                      ? "bi-chevron-right"
                                      : "bi-chevron-down"
                                  }`}
                                  onClick={toggleCardVisibility6}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">TH</span>
                              </Col>
                              <Col xs={12} md={8} lg={8}>
                                <span className="headerTitle">
                                  Three-Way Matching - Purchase Order /Invoice
                                  /Goods Receipt
                                </span>
                                <span className="subHeaderTitle">
                                  View of Three Way List{" "}
                                </span>
                              </Col>

                              {/* <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col> */}
                            </Row>
                          </h2>

                          <div
                            // id="acc"
                            className={`accordion-collapse collapse show ${
                              isCardVisible6 ? "visible" : ""
                            }`}
                            // aria-labelledby="headingOne"
                            // data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                              <Row>
                                <Col xs={12} md={12} lg={12}>
                                  <DataTable
                                    title=""
                                    columns={threeWayColInfo}
                                    data={getThreeWayMatch}
                                    progressPending={loading}
                                    paginationRowsPerPageOptions={
                                      Constants.ROW_PER_PAGE
                                    }
                                    pagination
                                    // paginationServer
                                    // paginationTotalRows={totalRows}
                                    // onChangeRowsPerPage={handlePerRowsChange}
                                    // onChangePage={handlePageChange}
                                    selectableRows
                                  />
                                </Col>
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </>
              ))}

            {getHeaderData?.grnVendorInvoiceNo && (
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible3
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility3}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">ID</span>
                      </Col>
                      <Col xs={12} md={8} lg={8}>
                        <span className="headerTitle">Invoice Details</span>
                        <span className="subHeaderTitle">Invoice Details</span>
                      </Col>

                      {/* <Col xs={2} md={1} lg={1} className="">
                          <POCollabrationCommonFillter />
                        </Col> */}
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible3 ? "visible" : ""
                    }`}
                    // aria-labelledby="headingOne"
                    // data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            id="grnVendorInvoiceNo"
                            className="inputBox"
                            label="Invoice Number"
                            // type="date"
                            name="grnVendorInvoiceNo"
                            placeholder=""
                            value={getHeaderData?.grnVendorInvoiceNo}
                            disabled={true}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            id="grnPurchasingDocumentDate"
                            className="inputBox"
                            label="Invoice Date"
                            // type="date"
                            name="grnPurchasingDocumentDate"
                            placeholder=""
                            value={formatDate(
                              getHeaderData?.grnPurchasingDocumentDate,
                            )}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            id="grnVendorTotalInvoiceValue"
                            className="inputBox"
                            label="Invoice Value"
                            // type="date"
                            name="grnVendorTotalInvoiceValue"
                            placeholder=""
                            value={getHeaderData?.grnVendorTotalInvoiceValue}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            id="grnGstValue"
                            className="inputBox"
                            label="Invoice GST Value"
                            // type="date"
                            name="grnGstValue"
                            placeholder=""
                            value={getHeaderData?.grnGstValue}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            id="grnTotalInvoiceValue"
                            className="inputBox"
                            label="Total Invoice Value"
                            // type="date"
                            name="grnTotalInvoiceValue"
                            placeholder=""
                            value={getHeaderData?.grnTotalInvoiceValue}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            id="grnEwayBillNumber"
                            className="inputBox"
                            label="E-Way Bill"
                            // type="date"
                            name="grnEwayBillNumber"
                            placeholder=""
                            value={getHeaderData?.grnEwayBillNumber || "--"}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            id="grnEwayBillExpiryDate"
                            className="inputBox"
                            label="E-Way Bill Date"
                            // type="date"
                            name="grnEwayBillExpiryDate"
                            placeholder=""
                            value={formatDate(
                              getHeaderData?.grnEwayBillExpiryDate,
                            )}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex flex-column"
                        >
                          <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion">
                            {" "}
                            Invoice Attachement
                          </label>
                          <img
                            src="assets/img/newIcons/attached-file.png"
                            className="mt-1 attachmentIcon"
                            alt="attachments"
                            onClick={() =>
                              handleViewFile(
                                getHeaderData?.grnShippingDocuments,
                              )
                            }
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Tally Status */}
            <POTallyStatusSection documentNumber={poNumber} />
          </div>
        </Col>
      </Row>

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      {/* Header Text  */}
      <CommonItemLevelDatatableModal
        show={getViewHeaderText}
        onHide={() => headerTextHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      {/* ASN Item Text  */}
      <CommonItemLevelDatatableModal
        show={getASNitemLevelModalShow}
        onHide={() => ASNItemLevelHideModal()}
        columns={ASNLineItemColInfo}
        data={getItemLevelData}
        title={getModalTitle}
      />

      {/* GRN Item Text  */}
      <CommonItemLevelDatatableModal
        show={getGRNitemLevelModalShow}
        onHide={() => GRNLItemLevelHideModal()}
        columns={GRNLineItemColInfo}
        data={getItemLevelData}
        title={getModalTitle}
      />

      {/* Invoice Item Text  */}
      <CommonItemLevelDatatableModal
        show={getInvoiceitemLevelModalShow}
        onHide={() => InvoiceItemLevelHideModal()}
        columns={InvoiceLineItemColInfo}
        data={getItemLevelData}
        title={getModalTitle}
      />

      {/* Invoice Item Text  */}
      <CommonItemLevelDatatableModal
        show={getSESitemLevelModalShow}
        onHide={() => SESLItemLevelHideModal()}
        columns={SESLineItemColInfo}
        data={getItemLevelData}
        title={getModalTitle}
      />

      {/* ThreeTwo Text  */}
      <CommonItemLevelDatatableModal
        show={getThreeTwoModalShow}
        onHide={() => threeTwoItemHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <FileViewerModalForHB
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
        showDelete={false}
      />
    </main>
  );
};

export default PurchaseOrderDetailedPage;
